/* ==========================================================================
   Paradermia,Page Bilan Micro-Nutrition Résultats (JS)

   Lit sessionStorage.pdn_bilan_result, hydrate la page entière et gère
   l'ajout panier + envoi email Klaviyo. Aucune dépendance au quiz : la
   page est autonome (le mini catalogue produits est embarqué pour les
   labels et prix, et complété si possible via Storefront API au runtime).
   ========================================================================== */

(function () {
  'use strict';

  // ── 2026-10-06 — Klaviyo sans script onsite ──────────────────────────────
  // Constat (audit) : paradermia.com ne charge pas klaviyo.js, donc les
  // window._learnq.push(...) des quiz n'étaient lus par personne (aucun
  // événement quiz depuis le 25/05/2026). Ce shim transforme les push
  // ['identify'|'track'] en appels à l'API client Klaviyo (clé publique
  // company_id, aucun secret). Si klaviyo.js est un jour chargé
  // (window.klaviyo défini), le shim s'efface et laisse faire le natif.
  (function () {
    var CID = 'SM95Gk';
    if (window.__pdKlaviyoShim || window.klaviyo) return;
    window.__pdKlaviyoShim = true;
    function anon() {
      try {
        var k = 'pd_anon_id', v = localStorage.getItem(k);
        if (!v) { v = 'pd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10); localStorage.setItem(k, v); }
        return v;
      } catch (_) { return 'pd-' + Date.now(); }
    }
    var ident = {};
    function send(path, data) {
      try {
        fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + CID, {
          method: 'POST', keepalive: true,
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: data })
        }).catch(function () {});
      } catch (_) {}
    }
    function profileAttrs(extra) {
      var a = Object.assign({}, extra || {}), out = {};
      if (a.$email) { out.email = a.$email; delete a.$email; }
      if (a.$first_name) { out.first_name = a.$first_name; delete a.$first_name; }
      if (a.$last_name) { out.last_name = a.$last_name; delete a.$last_name; }
      if (ident.email && !out.email) out.email = ident.email;
      if (ident.first_name && !out.first_name) out.first_name = ident.first_name;
      if (!out.email) out.anonymous_id = anon();
      var props = {};
      Object.keys(a).forEach(function (k) { if (k.charAt(0) !== '$' && a[k] !== undefined) props[k] = a[k]; });
      if (Object.keys(props).length) out.properties = props;
      return out;
    }
    var q = { push: function (cmd) {
      try {
        if (!Array.isArray(cmd)) return;
        if (cmd[0] === 'identify') {
          var pa = profileAttrs(cmd[1]);
          if (pa.email) ident.email = pa.email;
          if (pa.first_name) ident.first_name = pa.first_name;
          send('profiles', { type: 'profile', attributes: pa });
        } else if (cmd[0] === 'track') {
          send('events', { type: 'event', attributes: {
            properties: Object.assign({ source_page: location.pathname }, cmd[2] || {}),
            metric: { data: { type: 'metric', attributes: { name: String(cmd[1]) } } },
            profile: { data: { type: 'profile', attributes: profileAttrs() } }
          } });
        }
      } catch (_) {}
    } };
    var existing = window._learnq;
    if (Array.isArray(existing)) existing.forEach(function (c) { q.push(c); });
    window._learnq = q;
  })();

  const SS_KEY = 'pdn_bilan_result';

  // ============================================================
  // CATALOGUE LOCAL, labels + données de présentation
  // (synchronisé avec quiz-nutrition.js, source de vérité côté quiz)
  // ============================================================
  const CATALOGUE = {
    vitamine_d:    { nom: 'Vitamine D3',          actif: 'Vitamine D3 1000 UI',          handle: 'vitamine-d3',          prix: 22, forme: 'Gouttes huile', dosage: '1000 UI', moment: 'Matin avec repas', duree: '3 mois' },
    magnesium:     { nom: 'Magnésium',            actif: 'Bisglycinate de magnésium',     handle: 'magnesium-bisglycinate', prix: 26, forme: 'Gélule',        dosage: '300 mg',  moment: 'Soir au coucher',   duree: '2-3 mois' },
    omega3:        { nom: 'Oméga-3',              actif: 'EPA / DHA marin',                handle: 'omega-3-epa-dha',     prix: 32, forme: 'Capsule huile', dosage: '1000 mg', moment: 'Midi avec repas',   duree: '3 mois' },
    omega3_algue:  { nom: 'Oméga-3 algue',        actif: 'EPA / DHA végétal d\'algue',     handle: 'omega-3-algue',       prix: 38, forme: 'Capsule',       dosage: '500 mg',  moment: 'Midi avec repas',   duree: '3 mois' },
    zinc:          { nom: 'Zinc',                 actif: 'Bisglycinate de zinc',           handle: 'zinc-bisglycinate',   prix: 18, forme: 'Gélule',        dosage: '15 mg',   moment: 'Soir à jeun',       duree: '2 mois' },
    fer_femme:     { nom: 'Fer',                  actif: 'Bisglycinate de fer',            handle: 'fer-bisglycinate',    prix: 24, forme: 'Gélule',        dosage: '14 mg',   moment: 'Matin à jeun',      duree: '3 mois' },
    b12:           { nom: 'Vitamine B12',         actif: 'Méthylcobalamine',               handle: 'vitamine-b12',        prix: 19, forme: 'Sublingual',    dosage: '1000 µg', moment: 'Matin',             duree: '2-3 mois' },
    probiotiques:  { nom: 'Probiotiques',         actif: 'Souches multiples 30 mds',       handle: 'probiotiques-30-milliards', prix: 36, forme: 'Gélule gastro-rés.', dosage: '30 mds UFC', moment: 'Matin à jeun', duree: '2 mois' },
    vitamine_c:    { nom: 'Vitamine C',           actif: 'Vitamine C liposomale',          handle: 'vitamine-c-liposomale', prix: 28, forme: 'Capsule liposomale', dosage: '500 mg', moment: 'Matin avec repas', duree: '2-3 mois' },
    collagene:     { nom: 'Collagène',            actif: 'Peptides marins hydrolysés',     handle: 'collagene-marin',     prix: 42, forme: 'Poudre',        dosage: '10 g',    moment: 'Matin à jeun',      duree: '3 mois' },
    ashwagandha:   { nom: 'Ashwagandha',          actif: 'Ashwagandha KSM-66',             handle: 'ashwagandha-ksm66',   prix: 34, forme: 'Gélule',        dosage: '600 mg',  moment: 'Soir',              duree: '2 mois' },
    coq10:         { nom: 'CoQ10',                actif: 'Ubiquinol',                      handle: 'coq10-ubiquinol',     prix: 44, forme: 'Capsule huile', dosage: '100 mg',  moment: 'Midi avec repas',   duree: '3 mois' },
    vitamine_b:    { nom: 'Complexe B',           actif: 'B1, B2, B5, B6, B9, B12',        handle: 'complexe-b',          prix: 24, forme: 'Gélule',        dosage: '50 mg',   moment: 'Matin',             duree: '2-3 mois' },
    melatonine:    { nom: 'Mélatonine',           actif: 'Mélatonine 1 mg',                handle: 'melatonine-1mg',      prix: 16, forme: 'Comprimé',      dosage: '1 mg',    moment: '30 min av. coucher', duree: 'Cure 3-4 sem' },
    inositol:      { nom: 'Inositol',             actif: 'Myo-inositol',                   handle: 'myo-inositol',        prix: 30, forme: 'Poudre',        dosage: '2 g',     moment: 'Matin et soir',     duree: '3 mois' },
    // DEPRECATED V4 — non sourcé au catalogue, code mort.
    // Remplacé par collagene + vitamine_d dans objMap.articulations et Q15.menopause.
    calcium:       { nom: 'Calcium',              actif: 'Citrate de calcium',             handle: 'calcium-citrate',     prix: 22, forme: 'Comprimé',      dosage: '500 mg',  moment: 'Soir',              duree: '3 mois' },
    curcuma:       { nom: 'Curcuma',              actif: 'Curcuma + pipérine',             handle: 'curcuma-piperine',    prix: 28, forme: 'Gélule',        dosage: '500 mg',  moment: 'Avec repas gras',   duree: '2-3 mois' },
    spiruline:     { nom: 'Spiruline',            actif: 'Spiruline bio',                  handle: 'spiruline-bio',       prix: 22, forme: 'Comprimé',      dosage: '3 g',     moment: 'Matin',             duree: '2 mois' },
    zinc_selenium: { nom: 'Zinc-Sélénium',        actif: 'Zinc + sélénium',                handle: 'zinc-selenium',       prix: 26, forme: 'Gélule',        dosage: '15 mg + 100 µg', moment: 'Matin avec repas', duree: '2-3 mois' },
    // V4 NEW — vraie marque sourcée (Novoma Formule Boost Bio : maca + guarana + gingembre + acérola).
    maca:          { nom: 'Maca',                 actif: 'Maca + guarana + gingembre',     handle: 'novoma-formule-boost',    prix: 28, forme: 'Gélule',        dosage: 'Synergie maca + guarana', moment: 'Matin',             duree: '2 mois' },
    // V4 NEW — Biocyte Glutathion Liposomal Réduit 500mg.
    glutathion:    { nom: 'Glutathion',           actif: 'Glutathion liposomal réduit',    handle: 'biocyte-glutathion-liposomal', prix: 48, forme: 'Gélule',        dosage: '500 mg',  moment: 'Matin à jeun',      duree: '2-3 mois' },
    // V4 NEW — Biocyte N-Acétyl-Cystéine 590mg.
    nac:           { nom: 'N-Acétyl-Cystéine',    actif: 'N-Acétyl-Cystéine',              handle: 'biocyte-nac-590',     prix: 32, forme: 'Gélule',        dosage: '590 mg',  moment: 'Matin',             duree: '2-3 mois' },
    // V4 NEW — D-Lab Détox Anti-Sucres (berbérine + chrome + cannelle + NAC).
    berberine:     { nom: 'Berbérine',            actif: 'Berbérine + chrome + cannelle',  handle: 'dlab-detox-anti-sucres',  prix: 42, forme: 'Gélule',        dosage: 'Berbérine + cofacteurs', moment: 'Avec repas',        duree: '2-3 mois' },
    // V4 NEW — IN'OYA Sun'Oya Défense (lycopène + bêta-carotène + vit E/C + sélénium).
    lycopene_carotenoides: { nom: 'Caroténoïdes solaires', actif: 'Lycopène + bêta-carotène + Vit E/C + Se', handle: 'inoya-sunoya-defense', prix: 35, forme: 'Gélule', dosage: 'Lycopène + bêta-carotène', moment: 'Matin avec repas', duree: '1-2 mois' },
    // DEPRECATED — Morosil® non sourcé au catalogue, jamais recommandé (code mort).
    morosil:       { nom: 'Morosil®',             actif: 'Morosil® 400 + PEPTAN + L-carnitine', handle: 'biocyte-bruleur-morosil', prix: 46, forme: 'Poudre à diluer', dosage: 'Morosil® 400mg', moment: 'Matin avec repas', duree: '2 mois' },
    // DEPRECATED V4 — non sourcé au catalogue, code mort.
    // Entrée conservée pour ne pas casser une session sessionStorage antérieure qui référencerait encore la key.
    tribulus_maca: { nom: 'Tribulus + Maca',      actif: 'Tribulus + maca',                handle: 'tribulus-maca',       prix: 36, forme: 'Gélule',        dosage: '500 mg',  moment: 'Matin',             duree: '2 mois' },
    // DEPRECATED V4 — non sourcé au catalogue, code mort.
    // Remplacé par inositol + magnesium + nac dans objMap.hormonal_cycle et libido_femme.
    vitex:         { nom: 'Vitex',                actif: 'Vitex agnus-castus',             handle: 'vitex-gattilier',     prix: 26, forme: 'Gélule',        dosage: '200 mg',  moment: 'Matin',             duree: '3 mois' },
  };

  const FER_MENTION_TEXT =
    'Un bilan sanguin (ferritine) est recommandé avant de démarrer une supplémentation en fer. Ne pas prendre sans avis médical.';

  const MENTION_LEGALE_TEXT =
    'Ce bilan nutritionnel est réalisé à titre indicatif et ne constitue pas un diagnostic médical. En cas de pathologie, de traitement en cours ou de doute, consultez un professionnel de santé avant de démarrer une supplémentation.';

  // ============================================================
  // V6,CONSTANTS HERO + BANDES (port depuis quiz peau Sprint 2)
  // ============================================================

  // SVG icons inline (copiés de quiz-paradermia.js l.442), utilisés pour
  // les bandes V6 (heart = solution, info = why, warning = vigilances).
  const SVG = {
    heart:   '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    info:    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><circle cx="12" cy="8" r="0.5" fill="currentColor"/></svg>',
    warning: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 3 2 20h20L12 3z"/><line x1="12" y1="10" x2="12" y2="14"/><circle cx="12" cy="17" r="0.6" fill="currentColor"/></svg>',
  };

  // Labels objectif (synchronisé avec quiz-nutrition.js OBJECTIF_LABELS)
  // Utilisé pour le titre-em du hero quand `objectif_principal` du payload
  // n'est pas déjà capitalisé (rétrocompat).
  const OBJECTIF_LABELS = {
    energie:          'Énergie',
    immunite:         'Immunité',
    stress_chronique: 'Stress chronique',
    sommeil:          'Sommeil',
    hormonal_cycle:   'Équilibre hormonal',
    peau_phaneres:    'Peau & Phanères',
    digestion:        'Digestion',
    articulations:    'Articulations',
    concentration:    'Concentration',
    vitalite_femme:   'Vitalité féminine',
    sport:            'Sport & Récupération',
    projet_grossesse: 'Projet Grossesse',
    vitalite_homme:   'Vitalité masculine',
    // V2.1 — label genre-neutre cohérent avec libido femme côté UI quiz.
    libido:           'Libido & vitalité intime',
    fertilite_homme:  'Fertilité masculine',
    vitalite_neutre:  'Vitalité & Libido',
    // V4 — nouvel objectif principal (objMap equilibre_poids).
    equilibre_poids:  'Équilibre du poids',
  };

  // Mapping objectif → groupe couleur d'accent (5 groupes max).
  // Voir audit Q4, gold est le fallback (cohérence charte Paradermia).
  // Classes correspondantes en CSS : .pdnr-acc-orange/.pdnr-acc-blue/etc.
  const ACCENT_COLOR_MAP = {
    energie:          'orange',
    sport:            'orange',
    concentration:    'orange',
    sommeil:          'blue',
    stress_chronique: 'blue',
    hormonal_cycle:   'rose',
    projet_grossesse: 'rose',
    peau_phaneres:    'green',
    digestion:        'green',
    // V4 — equilibre_poids partage l'axe métabolique-microbiote avec
    // digestion (probiotiques + spiruline + morosil naturel végétal).
    // Cohérent avec la connotation verte de l'objMap (probiotiques 2 +
    // spiruline 2) et évite de diluer le 'gold' fallback déjà chargé.
    equilibre_poids:  'green',
    immunite:         'gold',
    articulations:    'gold',
    vitalite_femme:   'gold',
    vitalite_homme:   'gold',
    vitalite_neutre:  'gold',
    libido:           'gold',
    fertilite_homme:  'gold',
  };

  // Bénéfice ciblé par actif, affiché dans bande "Pourquoi cette cure".
  // Copy validé Sprint A V5. Si un actif de la cure n'a pas d'entrée ici,
  // il est silencieusement omis (pas d'erreur). Style: tiret cadratin —
  // pour la transition signaux → bénéfice.
  // Note: tribulus_maca, vitex, calcium retirés (deprecated V4, non sourcés).
  const WHY_ACTIFS_NUTRITION = {
    vitamine_d:        "Peu exposé à la lumière naturelle au quotidien — la D3 devrait restaurer votre immunité, renforcer vos os et redonner de l'éclat à votre peau que l'alimentation seule ne compense pas.",
    magnesium:         "Mâchoires serrées, tensions dans la nuque, récupération difficile — cette forme hautement absorbable de magnésium devrait vous détendre, améliorer votre sommeil et réduire votre stress physique.",
    omega3:            "Sans poisson gras régulier dans votre alimentation — les oméga-3 EPA/DHA devraient réduire votre inflammation, améliorer votre concentration et nourrir votre peau de l'intérieur.",
    omega3_algue:      "Votre alimentation végétalienne ne contient pas d'oméga-3 actifs — cette huile de microalgue devrait vous apporter directement l'EPA et le DHA dont votre organisme a besoin, sans compromis sur vos valeurs.",
    b12:               "Absente de tous les végétaux, la B12 ne peut pas venir de votre alimentation — cette supplémentation devrait protéger votre énergie et votre système nerveux sur le long terme.",
    vitamine_b:        "Fatigue persistante, concentration difficile, énergie en dents de scie — ces formes actives de vitamines B devraient vous redonner de l'énergie et de la clarté mentale rapidement.",
    vitamine_c:        "Votre immunité et votre collagène ont besoin d'un soutien efficace — cette forme liposomale devrait être absorbée bien mieux par votre organisme que la vitamine C classique.",
    coq10:             "Épuisement prolongé, récupération lente, coup de barre persistant — le CoQ10 devrait relancer votre production d'énergie cellulaire là où elle se joue vraiment.",
    ashwagandha:       "Toujours en tension, difficilement récupéré, stress qui s'accumule — l'ashwagandha KSM-66 devrait réduire votre cortisol, améliorer votre résistance au stress et vous aider à récupérer.",
    probiotiques:      "Ballonnements fréquents, transit irrégulier, inconfort après les repas — ces probiotiques gastro-résistants devraient restaurer votre équilibre intestinal et renforcer votre immunité de l'intérieur.",
    collagene:         "Peau qui perd en densité, ongles fragiles, articulations sensibles — ces peptides marins devraient relancer votre synthèse de collagène là où elle décline naturellement avec le temps.",
    melatonine:        "Endormissement difficile, réveils nocturnes, cycle décalé — cette dose physiologique de mélatonine devrait resynchroniser votre rythme veille-sommeil sans créer de dépendance.",
    curcuma:           "Digestion inconfortable, articulations sensibles, inflammation de fond — cette formule liposomale avec pipérine devrait être réellement absorbée par votre organisme, contrairement aux formes non titrées.",
    spiruline:         "Votre alimentation laisse peu de place au fer et aux protéines complètes — la spiruline bio devrait combler ces apports sous une forme que votre organisme assimile directement.",
    fer_femme:         "Froid aux extrémités, fatigue persistante, règles abondantes — cette formule bisglycinate devrait corriger un niveau de fer insuffisant tout en étant bien tolérée.",
    inositol:          "Cycle irrégulier, déséquilibre hormonal, SOPK suspecté — l'inositol devrait réguler votre axe ovarien et vous aider à retrouver progressivement un cycle régulier.",
    zinc:              "Peau réactive, cicatrisation lente, immunité fragile — le zinc bisglycinate devrait soutenir votre peau, votre immunité et votre équilibre hormonal de fond.",
    zinc_selenium:     "Vitalité en baisse, récupération lente — ce cofacteur direct de la testostérone et du sélénium thyroïdien devrait vous aider à retrouver votre énergie, votre drive et votre récupération.",
    maca:              "Énergie en retrait, libido diminuée, vitalité hormonale à soutenir — la maca devrait booster votre énergie et votre libido avec un profil d'actifs naturels bien documenté.",
    glutathion:        "Peau terne, stress oxydatif élevé, immunité sollicitée — ce maître antioxydant en forme liposomale devrait neutraliser les radicaux libres et éclaircir progressivement votre teint.",
    nac:               "Équilibre hormonal à soutenir, fertilité à optimiser, défense cellulaire à renforcer — la NAC devrait augmenter votre production de glutathion endogène et soutenir votre confort hormonal.",
    berberine:         "Envies sucrées intenses, digestion lourde, glycémie irrégulière — la berbérine devrait réguler votre métabolisme des sucres et rééquilibrer votre microbiote intestinal.",
    lycopene_carotenoides: "Peau exposée, immunité à booster, protection antioxydante à renforcer — ces caroténoïdes devraient protéger vos cellules du stress oxydatif et soutenir votre photoprotection cutanée inside-out.",
    morosil:           "Objectif silhouette, graisse abdominale persistante, tour de taille à affiner — cet extrait breveté d'orange Moro devrait contribuer à la réduction de la graisse localisée, cliniquement évalué sur 6 mois.",
  };

  // Synergies actives détectées dans la cure, assemblées dans la bande
  // "Pourquoi cette cure pour vous ?" (max 3 affichées). Copy validé.
  const WHY_CURE_INTRO =
    "Ces actifs ne sont pas une liste, ils ont été sélectionnés parce qu'ils fonctionnent mieux ensemble pour votre profil.";

  const WHY_CURE_FALLBACK =
    "Votre cure a été construite à partir de vos signaux spécifiques. Chaque actif a été sélectionné pour répondre à un besoin identifié dans votre profil, pas pour compléter une liste générique.";

  // V5 — synergies V4 alignées sur le catalogue sourcé.
  // Retirées : cycle_inositol_vitex (vitex deprecated), os_vitamined_calcium_magnesium (calcium deprecated).
  // Renommée : libido_homme_zinc_tribulus → libido_homme_zinc_maca (maca remplace tribulus_maca).
  // Ajoutées : poids_morosil_berberine (objectif equilibre_poids V4), nac_glutathion (axe antioxydant V4).
  const WHY_CURE_SYNERGIES = {
    stress_magnesium_ashwagandha:
      "Magnésium et ashwagandha agissent ensemble sur votre axe stress — l'un détend votre système nerveux physiquement, l'autre régule votre cortisol en profondeur.",
    sommeil_magnesium_melatonine:
      "Magnésium et mélatonine se complètent pour restaurer votre sommeil — l'un prépare la détente musculaire, l'autre resynchronise votre cycle veille-sommeil.",
    energie_coq10_vitamine_b:
      "CoQ10 et complexe B travaillent ensemble sur votre énergie cellulaire — deux cofacteurs indispensables à la même chaîne de production d'énergie.",
    vegan_b12_omega3_algue:
      "B12 et oméga-3 algue couvrent ensemble les deux carences les plus critiques d'une alimentation végétalienne — aucun des deux ne peut être compensé autrement.",
    peau_collagene_vitamine_c:
      "Collagène et vitamine C forment une synergie indispensable — la vitamine C est le cofacteur sans lequel le collagène ne peut pas être synthétisé par votre organisme.",
    immunite_vitamined_zinc_vitaminec:
      "Vitamine D, zinc et vitamine C forment le trio de référence pour votre immunité — trois actifs dont l'action synergique est la mieux documentée cliniquement.",
    fer_femme_vitaminec:
      "Le fer bisglycinate et la vitamine C forment une association classique en pharmacie — la vitamine C multiplie l'absorption du fer non-héminique par trois.",
    libido_homme_zinc_maca:
      "Zinc-sélénium et maca couvrent deux mécanismes distincts de la vitalité masculine — l'un sur la synthèse hormonale, l'autre sur l'énergie et le drive.",
    digestion_probiotiques_omega3:
      "Probiotiques et oméga-3 agissent en synergie sur votre microbiote et votre barrière intestinale — l'un repeuple, l'autre renforce et apaise l'inflammation de fond.",
    sport_magnesium_coq10:
      "Magnésium et CoQ10 couvrent ensemble vos besoins de récupération — l'un sur la détente musculaire, l'autre sur la recharge énergétique cellulaire.",
    poids_morosil_berberine:
      "Morosil et berbérine agissent sur deux leviers complémentaires de l'équilibre métabolique — l'un sur le tissu adipeux viscéral, l'autre sur la régulation glycémique et le microbiote.",
    nac_glutathion:
      "NAC et glutathion liposomal se renforcent mutuellement — la NAC augmente votre production de glutathion endogène pendant que la forme liposomale l'apporte directement.",
  };

  // ============================================================
  // V7 — CATÉGORISATION NUTRITION (Phase 2 port — Sprint 2 suite)
  // ============================================================
  // 5 catégories validées user pour les section headers numérotés du bloc
  // produits ("01 / VITAMINES", "02 / MINÉRAUX", etc.). L'ordre déclaré
  // ci-dessous est l'ordre d'affichage. Numérotation auto à partir des
  // catégories effectivement présentes dans la cure (skip cats vides).
  const NUTRITION_CAT_ORDER = ['vitamines', 'mineraux', 'omegas', 'microbiote', 'adaptogenes'];
  const NUTRITION_CAT_LABELS = {
    vitamines:   'Vitamines',
    mineraux:    'Minéraux',
    omegas:      'Omégas',
    microbiote:  'Microbiote & Plantes',
    adaptogenes: 'Adaptogènes & Spécifiques',
  };
  // Mapping actif → catégorie (cf. audit user step 4 validé).
  const NUTRITION_CAT_OF = {
    vitamine_d: 'vitamines', vitamine_b: 'vitamines', vitamine_c: 'vitamines', b12: 'vitamines',
    magnesium: 'mineraux', calcium: 'mineraux', zinc: 'mineraux',
    zinc_selenium: 'mineraux', fer_femme: 'mineraux',
    omega3: 'omegas', omega3_algue: 'omegas',
    probiotiques: 'microbiote', curcuma: 'microbiote', spiruline: 'microbiote',
    ashwagandha: 'adaptogenes', coq10: 'adaptogenes', melatonine: 'adaptogenes',
    inositol: 'adaptogenes', vitex: 'adaptogenes', tribulus_maca: 'adaptogenes',
    collagene: 'adaptogenes',
  };

  // SVG icons additionnels Phase 2 (bottle placeholder + filter Matin/Soir/Repas/Tous).
  // Étendent l'objet SVG existant (Phase V6 : heart, info, warning).
  SVG.bottle = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="8" y="3" width="8" height="3"/><path d="M9 6v3l-2 2v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-9l-2-2V6"/><line x1="9" y1="14" x2="15" y2="14"/></svg>';
  // V5.4 — icons minimalistes inline pour remplacer les emojis réassurance,
  // notice et slot verrouillé. Style outline cohérent (stroke 1.5, rounded).
  SVG.truck    = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v10H3z"/><path d="M14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>';
  SVG.return_  = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 14 4 9 9 4"/><path d="M4 9h11a5 5 0 0 1 5 5v0a5 5 0 0 1-5 5h-3"/></svg>';
  SVG.bookmark = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h12v18l-6-4-6 4V3z"/></svg>';
  SVG.lock     = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  SVG.lockLarge = '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
  SVG.document = '<svg viewBox="0 0 24 24" width="32" height="32" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><polyline points="14 3 14 8 19 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="15" y2="17"/></svg>';
  SVG.documentSmall = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><polyline points="14 3 14 8 19 8"/></svg>';
  SVG.grid   = '<svg viewBox="0 0 24 24" width="13" height="13" fill="currentColor" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>';
  SVG.sun    = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="4.2" y1="4.2" x2="6.3" y2="6.3"/><line x1="17.7" y1="17.7" x2="19.8" y2="19.8"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/><line x1="4.2" y1="19.8" x2="6.3" y2="17.7"/><line x1="17.7" y1="6.3" x2="19.8" y2="4.2"/></svg>';
  SVG.moon   = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>';
  // Repas : bowl (demi-cercle avec ligne horizontale) — 3ème filtre nutrition.
  SVG.repas  = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 10h18M4 10v3a8 8 0 0 0 16 0v-3"/></svg>';

  // ============================================================
  // STATE
  // ============================================================
  let bilan = null;             // contenu sessionStorage parsé
  let selected = {};            // { actifKey: bool }
  let _catalogueRemote = null;  // map handle → { variantId, price, title }
  let app = null;
  let _emailValue = '';
  // V5.3 — produits upsell parapharmacie. null = pas encore fetché,
  // [] = fetch fait mais vide, [{...}] = produits prêts à rendre.
  let _upsellProducts = null;
  let _upsellFetched = false;

  // ============================================================
  // HELPER h(), createElement (identique au quiz)
  // ============================================================
  function h(tag, attrs, children) {
    const el = document.createElement(tag);
    if (attrs) {
      Object.entries(attrs).forEach(([k, v]) => {
        if (v == null || v === false) return;
        if (k === 'html') el.innerHTML = v;
        else if (k === 'class') el.className = v;
        else if (k === 'dataset') Object.assign(el.dataset, v);
        else if (k === 'on') Object.entries(v).forEach(([ev, fn]) => el.addEventListener(ev, fn));
        else if (k === 'style' && typeof v === 'object') Object.assign(el.style, v);
        else el.setAttribute(k, v);
      });
    }
    if (children != null) {
      const list = Array.isArray(children) ? children : [children];
      list.forEach(c => {
        if (c == null || c === false) return;
        if (typeof c === 'string' || typeof c === 'number') el.appendChild(document.createTextNode(c));
        else el.appendChild(c);
      });
    }
    return el;
  }

  function formatPrice(p) {
    if (typeof p !== 'number') return '';
    return p.toFixed(2).replace('.', ',') + ' €';
  }

  function getProductData(key) {
    const c = CATALOGUE[key];
    if (!c) return null;
    // V5.8 — résolution 100% Storefront via tags. Si pas de match
    // (produit pas encore référencé Headless), on garde les données
    // cliniques locales mais SANS prix, SANS marque, SANS variantId →
    // la carte se rend en mode éducatif (no-commerce) pour éviter d'afficher
    // une fausse marque ou un prix indicatif obsolète.
    const remote = _catalogueRemote && _catalogueRemote[key];
    if (!remote) {
      // Mode éducatif : clinique seulement.
      return Object.assign({}, c, { prix: null, brand: null, variantId: null, handle: null, imageUrl: null });
    }
    return Object.assign({}, c, {
      prix: remote.price,
      title: remote.title,
      imageUrl: remote.imageUrl,
      brand: remote.vendor || null,
      handle: remote.handle,
      variantId: remote.variantId,
      tags: remote.tags || [],
    });
  }

  // ============================================================
  // PARSE sessionStorage
  // ============================================================
  function loadBilan() {
    let raw;
    try { raw = sessionStorage.getItem(SS_KEY); } catch (_) { return null; }
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (_) { return null; }
  }

  // ============================================================
  // RENDER
  // ============================================================
  function render() {
    if (!app || !app.root) return;
    app.root.innerHTML = '';
    if (!bilan) {
      app.root.appendChild(renderEmpty());
      return;
    }
    initSelected();

    // 2026-10-06 — Attache le bilan au panier dès l'affichage des résultats
    // (from_bilan_nutrition + _pd_bilan) : le code équivalent vivait dans
    // l'ancien flux mono-page quiz-nutrition.js, plus exécuté depuis la
    // redirection vers cette page → aucune commande nutrition ne portait
    // le bilan. Fire-and-forget, une fois par affichage.
    try {
      var _pdRaw = sessionStorage.getItem(SS_KEY);
      if (_pdRaw && !window.__pdBilanPersisted) {
        window.__pdBilanPersisted = true;
        fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { from_bilan_nutrition: 'true', _pd_bilan: _pdRaw } })
        }).catch(function () {});
      }
    } catch (_) {}

    // V6, applique la classe d'accent par objectif principal sur le root.
    // Reset des éventuelles classes accent précédentes (re-render idempotent).
    ['pdnr-acc-orange', 'pdnr-acc-blue', 'pdnr-acc-rose', 'pdnr-acc-green', 'pdnr-acc-gold']
      .forEach(c => app.root.classList.remove(c));
    app.root.classList.add(accentClassFor(bilan.objectif_principal_key));

    app.root.appendChild(renderHero());

    // V6,3 bandes structurées sous le hero (pattern card homepage) :
    // 1. Réussir votre cure (méthodologie universelle, accordéon fermé)
    // 2. Pourquoi cette cure pour vous ? (synergies dynamiques, accordéon fermé)
    // 3. Vigilances (alertes sécurité, point unique, visible si présentes)
    const bands = h('div', { class: 'pdnr-bands' });
    bands.appendChild(block_solution());
    const whyCure = block_why_cure();
    if (whyCure) bands.appendChild(whyCure);
    const vigilances = block_vigilances();
    if (vigilances) bands.appendChild(vigilances);
    app.root.appendChild(bands);

    const container = h('div', { class: 'pdnr-container' });
    // V7 — bloc unique produits (cards horizontales V7 + filter Matin/Soir/Repas
    // + section headers numérotés par catégorie). Remplace les 3 renderSection
    // V6 (ESSENTIELS / CIBLAGE / OPTION CONDITIONNELLE) — la pill OBLIGATOIRE
    // gère le cas fer_femme conditionnel (bilan ferritine préalable).
    container.appendChild(renderProductsBlock());

    // V5 Sprint A — renderPratique() retiré du flux. Le bloc « Votre protocole
    // en pratique » (semaines 1-4 / 5-8 / mois 3) est remplacé par la bande
    // « Réussir votre cure » conseil pharmacienne déjà rendue plus haut.
    // V5 Sprint B — renderAddons() retiré : les add-ons sont désormais
    // intégrés directement dans la section CONFORT de renderProductsBlock.
    // V5 Sprint C — renderTeaser() retiré : remplacé par la notice card
    // intégrée dans renderProductsBlock après la section CONFORT.
    container.appendChild(renderUpsell());
    container.appendChild(renderRecap());
    // V7.9 — renderMentionLegale() RETIRÉ du rendu page résultats.
    // Mentions légales déjà présentes dans le footer Dawn natif (theme.liquid).
    // Pas de duplication.
    app.root.appendChild(container);

    // V5.8 — Sticky CTA bar fixée en bas du viewport (mobile + desktop).
    // Hors du flux normal : injectée directement dans le body, ré-injectée
    // à chaque render() pour rester synchronisée avec l'état des selections.
    renderStickyCTA();
  }

  // V5.8 — Bar sticky bas viewport : total + nombre d'actifs commandables
  // + bouton AJOUTER AU PANIER. S'affiche dès qu'au moins 1 actif commandable
  // est coché. Reprend la même logique que renderRecapTotal pour le total.
  function renderStickyCTA() {
    // Remove l'ancienne instance si présente (re-render idempotent).
    const existing = document.querySelector('.pdnr-sticky-cta');
    if (existing) existing.remove();
    if (!bilan) return;

    const allKeys = [].concat(
      bilan.actifs_base || [],
      bilan.actifs_cible || [],
      bilan.actifs_conditionnel || [],
      (bilan.actifs_addon || []).map(a => typeof a === 'string' ? a : (a && a.key)).filter(Boolean)
    );
    const selectedKeys = allKeys.filter(k => selected[k]);
    const orderableKeys = selectedKeys.filter(k => {
      const d = getProductData(k);
      return d && d.variantId;
    });
    // Pas de sticky si rien de commandable — évite une bar fantôme tant que
    // le catalogue Headless n'a aucun match pour le protocole courant.
    if (orderableKeys.length === 0) return;

    let total = 0;
    orderableKeys.forEach(k => {
      const d = getProductData(k);
      if (d && typeof d.prix === 'number') total += d.prix;
    });

    const bar = h('div', { class: 'pdnr-sticky-cta' });
    const left = h('div', { class: 'pdnr-sticky-cta-left' });
    left.appendChild(h('span', {
      class: 'pdnr-sticky-cta-count',
    }, orderableKeys.length + (orderableKeys.length > 1 ? ' actifs' : ' actif')));
    left.appendChild(h('span', {
      class: 'pdnr-sticky-cta-total',
    }, formatPrice(total)));
    bar.appendChild(left);

    const cta = h('button', {
      class: 'pdnr-sticky-cta-btn',
      type: 'button',
      on: { click: () => addToCart(orderableKeys) },
    }, 'AJOUTER AU PANIER →');
    bar.appendChild(cta);

    document.body.appendChild(bar);
  }

  // ============================================================
  // V6 BANDES, block_solution / block_why_cure / block_vigilances
  // ============================================================

  // Bande 1,"Réussir votre cure" (méthodologie universelle, accordéon fermé)
  // Copy validé en session avec la pharmacienne (4 piliers).
  function block_solution() {
    const f = bandFrame({
      variant: 'solution',
      icon: SVG.heart,
      title: 'Réussir votre cure',
      accordion: true,
      collapsed: true
    });

    const body = h('div', { class: 'pdnr-band-body' });
    const inner = h('div', { class: 'pdnr-band-body-inner' });

    inner.appendChild(h('h4', {}, 'Les compléments, ça se mérite.'));
    inner.appendChild(h('p', {}, 'Votre cure a été construite à partir de vos signaux réels — pas d\'un profil générique. Chaque actif a une raison précise d\'être là.'));

    inner.appendChild(h('h4', {}, 'La patience est la règle.'));
    const pPatience = h('p', {});
    pPatience.appendChild(document.createTextNode('Les compléments travaillent en profondeur, au niveau cellulaire. Comptez '));
    pPatience.appendChild(h('strong', {}, '4 à 8 semaines'));
    pPatience.appendChild(document.createTextNode(' avant les premiers effets perceptibles — c\'est le temps qu\'il faut à votre organisme pour reconstruire ce qui manquait.'));
    inner.appendChild(pPatience);

    inner.appendChild(h('h4', {}, 'Une cure complète, pas des prises isolées.'));
    const pCompleteness = h('p', {});
    pCompleteness.appendChild(document.createTextNode('Un actif pris de façon irrégulière n\'apporte pas les résultats attendus. La constance sur '));
    pCompleteness.appendChild(h('strong', {}, '2 à 3 mois'));
    pCompleteness.appendChild(document.createTextNode(' fait infiniment plus qu\'une dose ponctuelle bien choisie.'));
    inner.appendChild(pCompleteness);

    inner.appendChild(h('h4', {}, 'Votre corps est un système.'));
    inner.appendChild(h('p', {}, 'Énergie, peau, sommeil, équilibre hormonal — tout est connecté. Soutenir un axe renforce les autres. C\'est tout l\'intérêt d\'une prescription pensée globalement.'));

    body.appendChild(inner);
    f.content.appendChild(body);

    // Badge CONSEIL PHARMACIENNE en uppercase (V5 — spec brief).
    f.content.appendChild(h('span', { class: 'pdnr-band-pill' }, 'CONSEIL PHARMACIENNE'));

    return f.wrap;
  }

  // Bande 2,"Pourquoi cette cure pour vous ?" (accordéon fermé)
  // Section "Synergies actives" : 1-3 synergies détectées dans la cure
  // (logique getActiveSynergies). Fallback générique si aucune.
  // Section "Pourquoi ces actifs" : table actif → bénéfice (WHY_ACTIFS_NUTRITION)
  // pour les actifs de la cure (base + cible + conditionnel).
  function block_why_cure() {
    const synergies = getActiveSynergies(bilan);
    const cure = []
      .concat(bilan.actifs_base || [])
      .concat(bilan.actifs_cible || [])
      .concat(bilan.actifs_conditionnel || []);
    const actifsWithCopy = cure.filter(k => WHY_ACTIFS_NUTRITION[k]);

    // Si rien à afficher (cure vide ET pas de fallback) → return null
    if (cure.length === 0 && synergies.length === 0) return null;

    const f = bandFrame({
      variant: 'why',
      icon: SVG.info,
      title: 'Pourquoi cette cure pour vous ?',
      accordion: true,
      collapsed: true
    });

    const body = h('div', { class: 'pdnr-band-body' });
    const inner = h('div', { class: 'pdnr-band-body-inner' });

    // Intro statique
    inner.appendChild(h('p', {}, WHY_CURE_INTRO));

    // Section synergies actives (max 3) ou fallback
    if (synergies.length > 0) {
      inner.appendChild(h('h4', {}, 'Synergies actives'));
      synergies.forEach(k => {
        inner.appendChild(h('p', {}, WHY_CURE_SYNERGIES[k]));
      });
    } else if (cure.length > 0) {
      inner.appendChild(h('p', {}, WHY_CURE_FALLBACK));
    }

    // V7 Phase 2 — Section "Pourquoi ces actifs" RETIRÉE de cette bande.
    // Le copy WHY_ACTIFS_NUTRITION est désormais affiché par-card dans
    // l'accordéon "Pourquoi pour vous" (renderProductCardV7), au plus près
    // du produit auquel il s'applique. Évite la duplication visuelle.

    body.appendChild(inner);
    f.content.appendChild(body);

    return f.wrap;
  }

  // Bande 3,"Vigilances" (visible si alertes, non-accordéon)
  // Remplace l'ancien renderAlerts(), point unique de sécurité.
  // Source: actifs_conditionnel (fer), ci_detectees (CI sécurité), depuis_quiz_peau.
  function block_vigilances() {
    const items = [];

    // Bilan ferritine si fer en conditionnel (toujours pour femme avec besoin fer)
    if ((bilan.actifs_conditionnel || []).indexOf('fer_femme') !== -1) {
      items.push({
        text: 'Bilan ferritine recommandé avant de démarrer la cure de fer. Ne pas démarrer sans contrôle médical pour éviter une surcharge.',
        type: 'fer_bilan'
      });
    }

    // Précautions actives, actifs écartés pour raison de sécurité
    if ((bilan.ci_detectees || []).length > 0) {
      items.push({
        text: 'Certains actifs ont été écartés de votre recommandation en raison de votre profil de sécurité (grossesse, traitement médical en cours, ou pathologie déclarée). Ce filtrage est conservateur, un avis médical est conseillé avant toute supplémentation si vous avez un doute.',
        type: 'ci_active'
      });
    }

    // Mention enrichissement quiz peau (positif, mais reste dans vigilances comme info)
    if (bilan.depuis_quiz_peau) {
      items.push({
        text: 'Recommandation enrichie à partir de votre Analyse de Peau Paradermia : les signaux croisés peau ↔ nutrition ont été pris en compte dans votre protocole.',
        type: 'profil_enrichi'
      });
    }

    if (items.length === 0) return null;

    const countLabel = items.length === 1 ? '1 point' : items.length + ' points';

    const f = bandFrame({
      variant: 'vigilance',
      icon: SVG.warning,
      title: 'Vigilances',
      accordion: true,
      collapsed: false  // ouvert par défaut, mais l'utilisateur peut fermer
    });

    // Insertion du pill "Sécurité · N points" en fin de header (aligné droite via CSS).
    // Puis on REPOSITIONNE le chevron tout à droite, après le pill, pour
    // harmoniser l'ordre visuel : title ... pill chevron (au lieu de title chevron pill).
    const header = f.content.querySelector('.pdnr-band-header');
    if (header) {
      header.appendChild(h('span', { class: 'pdnr-band-pill' }, 'Sécurité · ' + countLabel));
      const chevron = header.querySelector('.pdnr-band-chevron');
      if (chevron) header.appendChild(chevron); // appendChild d'un node existant le déplace en fin
    }

    // Wrap dans pdnr-band-body pour permettre la collapse via accordion
    // (l'utilisateur peut fermer même si ouvert par défaut).
    const body = h('div', { class: 'pdnr-band-body' });
    const list = h('ul', { class: 'pdnr-band-vigilance-list' });
    items.forEach(it => {
      const li = h('li', { class: 'pdnr-band-vigilance-item' });
      li.appendChild(h('span', { class: 'pdnr-band-vigilance-bullet' }));
      li.appendChild(h('p', { class: 'pdnr-band-vigilance-text' }, it.text));
      list.appendChild(li);
    });
    body.appendChild(list);
    f.content.appendChild(body);

    return f.wrap;
  }

  function initSelected() {
    (bilan.actifs_base || []).forEach(k => { selected[k] = true; });
    (bilan.actifs_cible || []).forEach(k => {
      if (selected[k] === undefined) selected[k] = true;
    });
    (bilan.actifs_conditionnel || []).forEach(k => {
      if (selected[k] === undefined) selected[k] = false;
    });
    (bilan.actifs_addon || []).forEach(k => {
      const ak = typeof k === 'string' ? k : (k && k.key);
      if (ak && selected[ak] === undefined) selected[ak] = false;
    });
  }

  // ============================================================
  // V7 PRODUITS — renderProductCardV7 + renderProductFilter + renderProductsBlock
  // ============================================================
  // Port depuis quiz-paradermia.js Sprint 2 V7. Cards horizontales image gauche
  // + content droite, pills tier saturation V7, accordéon "Pourquoi pour vous"
  // par card (alimenté par WHY_ACTIFS_NUTRITION). Filter Matin/Soir/Repas/Tous
  // sticky top droite. Section headers numérotés par catégorie nutrition
  // (5 cats : VITAMINES / MINÉRAUX / OMÉGAS / MICROBIOTE & PLANTES / ADAPTOGÈNES).

  // Etiquette tier en français (Essentiel / Recommandé / Confort)
  const TIER_LABEL_V7 = {
    essentiel: 'Essentiel', recommande: 'Recommandé', confort: 'Confort'
  };
  // Label moment pour la pill (avec icône)
  const MOMENT_LABEL_V7 = {
    matin: '☼ Matin',
    soir:  '☽ Soir',
    repas: '🍴 Avec repas',
    both:  '☼☽ Matin / Soir',
    all:   '⋯ Au choix'
  };

  // V5 — mapping explicite actif → moment de prise. Override de
  // `nutritionMomentFor` qui dérivait du champ libre `CATALOGUE[k].moment`.
  // Source unique de vérité côté UI bilan, indépendant des chaînes
  // descriptives du catalogue. Valeurs uppercase = spec brief V5.
  const MOMENT_PRISE = {
    vitamine_d:           'MATIN',
    magnesium:            'SOIR',
    omega3:               'REPAS',
    omega3_algue:         'REPAS',
    b12:                  'MATIN',
    vitamine_b:           'MATIN',
    vitamine_c:           'MATIN',
    coq10:                'MATIN',
    ashwagandha:          'SOIR',
    probiotiques:         'MATIN',
    collagene:            'MATIN',
    melatonine:           'SOIR',
    curcuma:              'REPAS',
    spiruline:            'MATIN',
    fer_femme:            'MATIN',
    inositol:             'MATIN',
    zinc:                 'MATIN',
    zinc_selenium:        'MATIN',
    maca:                 'MATIN',
    glutathion:           'MATIN',
    nac:                  'MATIN',
    berberine:            'REPAS',
    lycopene_carotenoides: 'MATIN',
    morosil:              'REPAS',
  };
  // Conversion uppercase brief → lowercase pour MOMENT_LABEL_V7 lookup.
  const MOMENT_PRISE_LOWER = { MATIN: 'matin', SOIR: 'soir', REPAS: 'repas' };

  // V5 — labels et descriptions des 3 sections role côté UI bilan.
  // Affichés en en-tête de section avec accordéon ⓘ fermé par défaut.
  const CATEGORIE_LABELS = {
    essentiels:  'ESSENTIELS',
    recommandes: 'RECOMMANDÉS',
    confort:     'CONFORT',
  };
  const CATEGORIE_DESCRIPTIONS = {
    essentiels:  "Les actifs sélectionnés spécifiquement pour votre profil et votre objectif prioritaire.",
    recommandes: "Des actifs complémentaires pour affiner votre cure selon vos objectifs secondaires et signaux cliniques.",
    confort:     "Des synergies documentées pour amplifier les effets de votre cure dans la durée.",
  };

  // Carte produit V7 horizontale pour un actif donné.
  // role = 'essentiel' (Inclus, locked) | 'recommande' (CTA Ajouter/Ajouté)
  // | 'confort' (CTA optionnel, dashed pill).
  function renderProductCardV7(actifKey, role, opts) {
    const data = getProductData(actifKey);
    if (!data) return h('div', { style: { display: 'none' } });
    opts = opts || {};
    const moment = nutritionMomentFor(actifKey);
    const isEssential = role === 'essentiel';
    const isObligatoire = nutritionIsObligatoire(actifKey, bilan);
    const isAdded = !!selected[actifKey];

    const card = h('article', {
      class: 'pdnr-prod-v7' + (isEssential ? ' is-essential' : ''),
      'data-actif-key': actifKey,
      'data-product-role': role,
      'data-moment': moment,
    });

    const row = h('div', { class: 'pdnr-prod-v7-row' });

    // Image gauche — clic vers /products/{handle} target=_blank si handle.
    const productHref = data.handle ? '/products/' + data.handle : null;
    const imgZone = productHref
      ? h('a', {
          class: 'pdnr-prod-v7-image pdnr-prod-v7-image-link',
          href: productHref,
          target: '_blank',
          rel: 'noopener',
          'aria-label': 'Voir ' + (data.nom || data.actif || 'le produit'),
        })
      : h('div', { class: 'pdnr-prod-v7-image' });

    // Tentative image immédiate : V5.5 priorité à l'image featured résolue
    // par actif_key (data.imageUrl via getProductData), fallback resolveImageUrl
    // par handle puis fetch async /products/{handle}.js.
    const imgUrl = data.imageUrl || resolveImageUrl(data.handle);
    if (imgUrl) {
      imgZone.appendChild(h('img', { src: imgUrl, alt: data.nom || '', loading: 'lazy' }));
    } else {
      // Placeholder bottle SVG. Async fetch non-bloquant qui remplace
      // le placeholder par l'image fetchée si disponible.
      imgZone.appendChild(h('span', { html: SVG.bottle, style: 'color:rgba(30,61,16,0.25);' }));
      if (data.handle) {
        fetchProductImage(data.handle).then(url => {
          if (!url) return;
          imgZone.innerHTML = '';
          const img = h('img', { src: url, alt: data.nom || '', loading: 'lazy' });
          imgZone.appendChild(img);
        });
      }
    }
    if (productHref) {
      imgZone.addEventListener('click', (e) => e.stopPropagation());
    }
    row.appendChild(imgZone);

    // Content droite
    const content = h('div', { class: 'pdnr-prod-v7-content' });
    if (data.brand) {
      content.appendChild(h('div', { class: 'pdnr-prod-v7-eyebrow' }, data.brand));
    }
    // V5.8 — Nom = vrai titre Shopify (data.title du remote Storefront)
    // en priorité, fallback nom d'actif générique du CATALOGUE clinique.
    // Évite d'afficher « Magnésium » quand le vrai produit s'appelle
    // « D-Lab — Activateur d'Équilibre ».
    const nameInner = data.title || data.nom || data.actif || '';
    if (productHref) {
      const nameLink = h('a', {
        class: 'pdnr-prod-v7-name pdnr-prod-v7-name-link',
        href: productHref, target: '_blank', rel: 'noopener',
      }, nameInner);
      nameLink.addEventListener('click', (e) => e.stopPropagation());
      const nameWrap = h('h3', { class: 'pdnr-prod-v7-name' });
      nameWrap.appendChild(nameLink);
      content.appendChild(nameWrap);
    } else {
      content.appendChild(h('h3', { class: 'pdnr-prod-v7-name' }, nameInner));
    }
    // Description courte = forme + dosage (ex: "Gélule · 300 mg")
    const descParts = [data.forme, data.dosage].filter(Boolean);
    if (descParts.length) {
      content.appendChild(h('p', { class: 'pdnr-prod-v7-desc' }, descParts.join(' · ')));
    }

    // Pills row : tier + moment + (OBLIGATOIRE si fer ferritine)
    const pills = h('div', { class: 'pdnr-prod-v7-pills' });
    pills.appendChild(h('span', {
      class: 'pdnr-prod-v7-pill pdnr-prod-v7-pill--' + role,
    }, TIER_LABEL_V7[role] || ''));
    pills.appendChild(h('span', {
      class: 'pdnr-prod-v7-pill pdnr-prod-v7-pill--moment',
    }, MOMENT_LABEL_V7[moment] || MOMENT_LABEL_V7.all));
    if (isObligatoire) {
      pills.appendChild(h('span', {
        class: 'pdnr-prod-v7-pill pdnr-prod-v7-pill--obligatoire',
      }, 'Bilan préalable'));
    }
    content.appendChild(pills);

    // Bottom row : pourquoi-toggle + spacer + price + status/CTA
    const bottom = h('div', { class: 'pdnr-prod-v7-bottom' });

    const whyToggle = h('button', {
      class: 'pdnr-prod-v7-why', type: 'button', 'aria-expanded': 'false',
    });
    whyToggle.appendChild(h('span', { class: 'pdnr-prod-v7-why-chevron' }, '▾'));
    whyToggle.appendChild(document.createTextNode(' Pourquoi pour vous'));
    whyToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const opened = card.classList.toggle('is-why-open');
      whyToggle.setAttribute('aria-expanded', opened ? 'true' : 'false');
    });
    bottom.appendChild(whyToggle);
    bottom.appendChild(h('span', { class: 'pdnr-prod-v7-spacer' }));

    if (typeof data.prix === 'number') {
      bottom.appendChild(h('span', { class: 'pdnr-prod-v7-price' }, formatPrice(data.prix)));
    }

    // V5.8 — produit pas encore référencé Headless (pas de variantId
    // Storefront) → état "Bientôt disponible" non cliquable, l'actif reste
    // affiché en mode éducatif pour ne pas casser la lecture clinique.
    const isAvailable = !!data.variantId;
    if (isEssential) {
      bottom.appendChild(h('span', {
        class: 'pdnr-prod-v7-status' + (isAvailable ? '' : ' is-soon'),
      }, isAvailable ? 'Inclus' : 'Bientôt'));
    } else if (!isAvailable) {
      bottom.appendChild(h('span', {
        class: 'pdnr-prod-v7-status is-soon',
      }, 'Bientôt'));
    } else {
      const cta = h('button', {
        class: 'pdnr-prod-v7-cta' + (isAdded ? ' is-added' : ''),
        type: 'button',
      }, isAdded ? '✓ Ajouté' : '+ Ajouter');
      cta.addEventListener('click', (e) => {
        e.stopPropagation();
        selected[actifKey] = !selected[actifKey];
        render(); // re-render full pour mettre à jour le recap + total
      });
      bottom.appendChild(cta);
    }
    content.appendChild(bottom);
    row.appendChild(content);
    card.appendChild(row);

    // Why-pour-vous body — copy depuis WHY_ACTIFS_NUTRITION (validé pharmacienne).
    // Fallback discret si actif sans copy (rare, géré).
    const whyText = WHY_ACTIFS_NUTRITION[actifKey] ||
      'Sélectionné pour répondre à un besoin identifié dans votre profil.';
    const whyBody = h('div', { class: 'pdnr-prod-v7-why-body' });
    const whyInner = h('div', { class: 'pdnr-prod-v7-why-inner' }, whyText);
    whyBody.appendChild(whyInner);
    card.appendChild(whyBody);

    return card;
  }

  // Filter sticky pill : Tous / Matin / Repas / Soir.
  // 4 boutons. Tous = état initial actif. Le filter masque les cards dont
  // data-moment ne match pas (sauf 'both' qui apparaît sur tous les filtres).
  function renderProductFilter() {
    const filter = h('div', { class: 'pdnr-prod-filter' });
    const makeBtn = (filterValue, iconHtml, label, active) => {
      const btn = h('button', {
        class: 'pdnr-prod-filter-btn' + (active ? ' is-active' : ''),
        type: 'button',
        'data-filter': filterValue,
      });
      btn.appendChild(h('span', { html: iconHtml, style: 'display:inline-flex' }));
      btn.appendChild(document.createTextNode(' ' + label));
      btn.addEventListener('click', () => {
        filter.querySelectorAll('.pdnr-prod-filter-btn').forEach(b =>
          b.classList.remove('is-active'));
        btn.classList.add('is-active');
        applyMomentFilter(filterValue);
      });
      return btn;
    };
    filter.appendChild(makeBtn('all',   SVG.grid,  'Tous',  true));
    filter.appendChild(makeBtn('matin', SVG.sun,   'Matin', false));
    filter.appendChild(makeBtn('repas', SVG.repas, 'Repas', false));
    filter.appendChild(makeBtn('soir',  SVG.moon,  'Soir',  false));
    return filter;
  }

  // Applique le filtre moment : masque les cards dont data-moment ne match
  // pas. Cards avec moment='both' restent toujours visibles. Les sections
  // catégorie devenues vides après filtrage sont aussi masquées.
  function applyMomentFilter(filterValue) {
    const cards = document.querySelectorAll('.pdnr-prod-v7[data-moment]');
    cards.forEach(card => {
      const m = card.getAttribute('data-moment');
      const visible = filterValue === 'all' || m === 'both' || m === filterValue;
      card.style.display = visible ? '' : 'none';
    });
    // Masquer les sections catégorie vides
    document.querySelectorAll('.pdnr-prod-cat-section').forEach(section => {
      const visibleCount = Array.from(section.querySelectorAll('.pdnr-prod-v7'))
        .filter(c => c.style.display !== 'none').length;
      section.style.display = visibleCount === 0 ? 'none' : '';
    });
  }

  // V5 — En-tête de section role avec label + compteur + accordéon ⓘ
  // (description fermée par défaut, ouverte au clic).
  function renderCategorieHeader(categorieKey, count) {
    const header = h('div', { class: 'pd-categorie-header' });
    const left = h('div', { class: 'pd-categorie-left' });
    left.appendChild(h('span', { class: 'pd-categorie-label' }, CATEGORIE_LABELS[categorieKey]));
    const countStr = '— ' + count + ' PRODUIT' + (count > 1 ? 'S' : '');
    left.appendChild(h('span', { class: 'pd-categorie-count' }, countStr));
    header.appendChild(left);

    const desc = h('div', { class: 'pd-categorie-desc', hidden: true },
      CATEGORIE_DESCRIPTIONS[categorieKey]);

    const infoBtn = h('button', {
      class: 'pd-categorie-info',
      type: 'button',
      'aria-expanded': 'false',
      'aria-label': 'À propos de ' + CATEGORIE_LABELS[categorieKey],
    }, 'ⓘ');
    infoBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const opened = infoBtn.getAttribute('aria-expanded') === 'true';
      infoBtn.setAttribute('aria-expanded', opened ? 'false' : 'true');
      if (opened) desc.setAttribute('hidden', '');
      else desc.removeAttribute('hidden');
    });
    header.appendChild(infoBtn);

    return { header, desc };
  }

  // V5 — Carte « Notice de cure personnalisée », insérée dans la liste
  // après les CONFORT. Non cliquable (pas d'ajout panier, pas de checkbox),
  // badge OFFERT or + badge INCLUS vert, accordéon « En savoir plus ».
  function renderNoticeCard() {
    const card = h('article', {
      class: 'pdnr-prod-v7 pdnr-prod-notice',
      'data-actif-key': '__notice__',
      'data-product-role': 'notice',
    });
    const row = h('div', { class: 'pdnr-prod-v7-row' });

    const imgZone = h('div', { class: 'pdnr-prod-v7-image pdnr-prod-notice-image' });
    imgZone.appendChild(h('span', { class: 'pdnr-prod-notice-icon', html: SVG.document }));
    row.appendChild(imgZone);

    const content = h('div', { class: 'pdnr-prod-v7-content' });
    content.appendChild(h('div', { class: 'pdnr-prod-v7-eyebrow' }, 'PARADERMIA'));
    content.appendChild(h('h3', { class: 'pdnr-prod-v7-name' }, 'Notice de cure personnalisée'));
    content.appendChild(h('p', { class: 'pdnr-prod-v7-desc' },
      'Rédigée par notre Docteure en Pharmacie'));

    // Badges : OFFERT or (#C9A84C) + INCLUS vert.
    const pills = h('div', { class: 'pdnr-prod-v7-pills' });
    pills.appendChild(h('span', {
      class: 'pdnr-prod-v7-pill pdnr-prod-notice-pill--offert',
    }, 'OFFERT'));
    pills.appendChild(h('span', {
      class: 'pdnr-prod-v7-pill pdnr-prod-v7-pill--essentiel',
    }, 'INCLUS'));
    content.appendChild(pills);

    // Bottom : toggle « En savoir plus » + bouton statique non cliquable.
    const bottom = h('div', { class: 'pdnr-prod-v7-bottom' });

    const whyToggle = h('button', {
      class: 'pdnr-prod-v7-why', type: 'button', 'aria-expanded': 'false',
    });
    whyToggle.appendChild(h('span', { class: 'pdnr-prod-v7-why-chevron' }, '▾'));
    whyToggle.appendChild(document.createTextNode(' En savoir plus'));
    whyToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const opened = card.classList.toggle('is-why-open');
      whyToggle.setAttribute('aria-expanded', opened ? 'true' : 'false');
    });
    bottom.appendChild(whyToggle);
    bottom.appendChild(h('span', { class: 'pdnr-prod-v7-spacer' }));
    bottom.appendChild(h('span', { class: 'pdnr-prod-v7-status pdnr-prod-notice-status' }, 'Inclus'));
    content.appendChild(bottom);

    row.appendChild(content);
    card.appendChild(row);

    // Accordéon « En savoir plus » — corps replié par défaut.
    const whyBody = h('div', { class: 'pdnr-prod-v7-why-body' });
    whyBody.appendChild(h('div', { class: 'pdnr-prod-v7-why-inner' },
      'Retrouvez votre notice complète dans votre commande et dans votre espace membres dès validation de votre achat. Elle détaille les protocoles de prise, les associations à respecter et le calendrier de cure.'));
    card.appendChild(whyBody);

    return card;
  }

  // V5 — Slot ciblage verrouillé en mode partial. Affiché entre Essentiels
  // et Recommandés quand `payload.ciblage_partial === true`. Une carte
  // grisée + badge RECOMMANDÉ grisé + CTA continue mon bilan.
  function renderCiblageVerrouille() {
    const card = h('article', {
      class: 'pdnr-prod-v7 pdnr-prod-locked',
      'aria-label': 'Actif recommandé verrouillé — complétez votre bilan pour le débloquer',
    });
    const row = h('div', { class: 'pdnr-prod-v7-row' });

    const imgZone = h('div', { class: 'pdnr-prod-v7-image pdnr-prod-locked-image' });
    imgZone.appendChild(h('span', { class: 'pdnr-prod-locked-icon', html: SVG.lockLarge }));
    row.appendChild(imgZone);

    const content = h('div', { class: 'pdnr-prod-v7-content' });
    content.appendChild(h('p', { class: 'pdnr-prod-v7-eyebrow pdnr-prod-locked-eyebrow' },
      'Actif recommandé'));
    content.appendChild(h('h3', { class: 'pdnr-prod-v7-name pdnr-prod-locked-name' },
      'Complétez votre Protocole Personnalisé pour débloquer vos actifs Recommandés'));

    const pills = h('div', { class: 'pdnr-prod-v7-pills' });
    pills.appendChild(h('span', {
      class: 'pdnr-prod-v7-pill pdnr-prod-v7-pill--recommande pdnr-prod-locked-pill',
    }, 'Recommandé'));
    content.appendChild(pills);

    const bottom = h('div', { class: 'pdnr-prod-v7-bottom' });
    bottom.appendChild(h('span', { class: 'pdnr-prod-v7-spacer' }));
    const cta = h('a', {
      class: 'pdnr-prod-locked-cta',
      href: (typeof window !== 'undefined' && window.PARADERMIA_NUTRITION_QUIZ_URL) || '/pages/quiz-nutrition',
    }, 'Continuer mon bilan →');
    bottom.appendChild(cta);
    content.appendChild(bottom);

    row.appendChild(content);
    card.appendChild(row);
    return card;
  }

  // Bloc principal V5 — "Votre cure produit par produit" + filter sticky +
  // 3 sections par role (ESSENTIELS / RECOMMANDÉS / CONFORT) avec en-tête
  // accordéon ⓘ. Slot ciblage verrouillé en mode partial entre Essentiels
  // et Recommandés. Les add-ons sont intégrés dans CONFORT (plus de
  // renderAddons séparé).
  function renderProductsBlock() {
    const wrap = h('section', { class: 'pdnr-block-products' });

    // Eyebrow + titre standard (réutilise pattern V7.section)
    const sectionTitle = h('div', { class: 'pdnr-section-v7' });
    sectionTitle.appendChild(h('div', { class: 'pdnr-section-v7-eyebrow' }, 'VOTRE CURE'));
    sectionTitle.appendChild(h('h2', { class: 'pdnr-section-v7-h2' }, 'Votre cure produit par produit'));
    wrap.appendChild(sectionTitle);

    // Filter sticky Matin/Repas/Soir/Tous — applique sur toutes les cards
    // [data-moment] indépendamment de la section role.
    wrap.appendChild(renderProductFilter());

    // Helper : rend une section role complète (header + desc + cards).
    // `items` est un array d'objets { key, role, justification? }.
    const renderRoleSection = (categorieKey, items) => {
      if (!items || items.length === 0) return null;
      const section = h('div', {
        class: 'pdnr-prod-cat-section pdnr-prod-cat-section--' + categorieKey,
        'data-categorie': categorieKey,
      });
      const { header, desc } = renderCategorieHeader(categorieKey, items.length);
      section.appendChild(header);
      section.appendChild(desc);
      items.forEach(item => {
        section.appendChild(renderProductCardV7(item.key, item.role));
      });
      return section;
    };

    // ESSENTIELS = actifs_base, role='essentiel'.
    const essentielsItems = (bilan.actifs_base || []).map(k => ({ key: k, role: 'essentiel' }));
    const essentielsSection = renderRoleSection('essentiels', essentielsItems);
    if (essentielsSection) wrap.appendChild(essentielsSection);

    // V5 — slot ciblage verrouillé si ciblage_partial true. Affiché AVANT
    // la section Recommandés (typiquement vide en partial).
    if (bilan.ciblage_partial === true) {
      wrap.appendChild(renderCiblageVerrouille());
    }

    // RECOMMANDÉS = actifs_cible + actifs_conditionnel, role='recommande'.
    // L'ordre cible puis conditionnel préserve la priorité scoring algo.
    const recommandesItems = [].concat(
      (bilan.actifs_cible || []).map(k => ({ key: k, role: 'recommande' })),
      (bilan.actifs_conditionnel || []).map(k => ({ key: k, role: 'recommande' }))
    );
    const recommandesSection = renderRoleSection('recommandes', recommandesItems);
    if (recommandesSection) wrap.appendChild(recommandesSection);

    // CONFORT = actifs_addon, role='confort'. Les addons sont des objets
    // { key, justification, type } — on extrait juste la key pour la carte.
    const confortItems = (bilan.actifs_addon || []).map(a => ({
      key: typeof a === 'string' ? a : (a && a.key),
      role: 'confort',
    })).filter(item => item.key);
    const confortSection = renderRoleSection('confort', confortItems);
    if (confortSection) wrap.appendChild(confortSection);

    // V5 — carte « Notice de cure personnalisée » insérée en fin de liste,
    // toujours visible quel que soit le profil (cure incluse offerte).
    wrap.appendChild(renderNoticeCard());

    return wrap;
  }

  // ----- État vide -----
  function renderEmpty() {
    const wrap = h('div', { class: 'pdnr-empty' });
    wrap.appendChild(h('h1', { class: 'pdnr-empty-title' }, 'Votre bilan a expiré'));
    wrap.appendChild(h('p', { class: 'pdnr-empty-text' },
      'Pour des raisons de confidentialité, votre bilan ne reste pas en mémoire d\'une visite à l\'autre. Relancez le quiz en quelques minutes pour générer un nouveau protocole.'));
    const cta = h('a', {
      class: 'pdnr-empty-cta',
      href: window.PARADERMIA_NUTRITION_QUIZ_URL || '/pages/quiz-nutrition',
    }, 'Recommencer le bilan →');
    wrap.appendChild(cta);
    return wrap;
  }

  // ----- HERO V6, carte ivoire ordonnance (port depuis quiz peau Sprint 2) -----
  // Structure : méta header (brand + N°/date) → greeting → titre 2 lignes
  // (pré-titre Playfair + objectif italic accent) → descripteur + niveau pill
  // → 3 stats hairlines (Profil / Priorité / Objectif).
  function renderHero() {
    const wrap = h('section', { class: 'pdnr-rh' });

    // ── Méta header : brand + N° référence + date snapshot ──
    // Date = _meta.completedAt (snapshot) || _generated_at (rétrocompat sessions
    // antérieures à la migration data shape). Jamais Date.now() ici.
    const meta = (bilan && bilan._meta) || {};
    const completedAtMs = meta.completedAt || bilan._generated_at || Date.now();
    const dateStr = formatAnalysisDate(completedAtMs);
    // Counter per-person : pour la 1ère analyse hors espace membre, "01".
    // À brancher sur metafield Shopify customer.custom.analysis_count quand membre.
    const refNum = '01';

    const metaEl = h('header', { class: 'pdnr-rh-meta' });
    metaEl.appendChild(h('span', { class: 'pdnr-rh-meta-brand' }, 'Bilan Micro nutrition Paradermia'));
    const serial = h('span', { class: 'pdnr-rh-meta-serial' });
    serial.appendChild(h('span', { class: 'pdnr-rh-meta-serial-num' }, 'N° ' + refNum));
    serial.appendChild(h('span', { class: 'pdnr-rh-meta-serial-sep' }, '·'));
    serial.appendChild(document.createTextNode(dateStr));
    metaEl.appendChild(serial);
    wrap.appendChild(metaEl);

    // ── Greeting "Pour {firstName}," ou fallback "Pour vous," (V5.4) ──
    const firstName = (meta.firstName && meta.firstName.trim())
      ? meta.firstName.trim() : null;
    const greetingText = firstName ? 'Pour ' + firstName + ',' : 'Pour vous,';
    wrap.appendChild(h('p', { class: 'pdnr-rh-greeting' }, greetingText));

    // ── Titre 2 lignes : pré-titre + objectif italic accent ──
    // Pré-titre dynamique selon parcours (partiel = base, complet = personnalisée).
    // Wording validé user : "Votre cure {de base|personnalisée}." avec point final.
    const titlePre = bilan.score_personnalisation === 'partiel'
      ? 'Votre cure de base.'
      : 'Votre cure personnalisée.';
    const titleEm = (bilan.objectif_principal || 'Personnalisé') + '.';

    const titleWrap = h('h1', { class: 'pdnr-rh-title' });
    titleWrap.appendChild(h('span', { class: 'pdnr-rh-title-pre' }, titlePre));
    titleWrap.appendChild(h('span', { class: 'pdnr-rh-title-em' }, titleEm));
    wrap.appendChild(titleWrap);

    // ── Descripteur : "Cure {focus} · OPTIMAL/RECOMMANDÉ." ──
    // Le focus est dérivé du label objectif principal (déjà capitalisé).
    // Mot "Cure" (au lieu de Protocole) pour cohérence avec le titre principal
    // "Votre cure ..." et la bande "Réussir votre cure".
    const level = levelLabel(bilan.score_personnalisation);
    const focus = (bilan.objectif_principal || 'personnalisée').toLowerCase();
    const descriptor = h('p', { class: 'pdnr-rh-descriptor' });
    descriptor.appendChild(document.createTextNode('Cure ' + focus + ' · '));
    descriptor.appendChild(h('strong', {}, level));
    descriptor.appendChild(document.createTextNode('.'));
    wrap.appendChild(descriptor);

    // ── 3 stats hairlines : Profil / Priorité / Objectif ──
    // PROFIL : "Femme · 25–34 ans" (genre + age combinés)
    // PRIORITÉ : 1er actif de actifs_base via CATALOGUE[k].nom (— si vide)
    // OBJECTIF : OBJECTIF_LABELS[objectif_principal_key] || objectif_principal
    const stats = h('div', { class: 'pdnr-rh-stats' });

    // PROFIL
    const g = genreLabel(bilan.genre);
    const a = ageLabel(bilan.age);
    let profilStr = null;
    if (g && a) profilStr = g + ' · ' + a;
    else if (g) profilStr = g;
    else if (a) profilStr = a;
    stats.appendChild(makeRhStat('Profil', profilStr, !profilStr));

    // PRIORITÉ,1er actif baseEssentielle via CATALOGUE
    const baseList = bilan.actifs_base || [];
    const priorityKey = baseList.length > 0 ? baseList[0] : null;
    const priorityLabel = priorityKey && CATALOGUE[priorityKey]
      ? CATALOGUE[priorityKey].nom
      : null;
    stats.appendChild(makeRhStat('Priorité', priorityLabel, !priorityLabel));

    // OBJECTIF, preferred: OBJECTIF_LABELS[key], fallback: objectif_principal raw
    const objLabel = (bilan.objectif_principal_key && OBJECTIF_LABELS[bilan.objectif_principal_key])
      || bilan.objectif_principal
      || null;
    stats.appendChild(makeRhStat('Objectif', objLabel, !objLabel));

    wrap.appendChild(stats);

    return wrap;
  }

  function capitalize(s) {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // ============================================================
  // V6 HELPERS, bandFrame, formatAnalysisDate, makeRhStat, getActiveSynergies
  // ============================================================

  // Format date "8 mai 2026" depuis timestamp ms (registre français).
  function formatAnalysisDate(ms) {
    try {
      const d = new Date(ms);
      const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
    } catch (_) { return ''; }
  }

  // Fabrique une cellule stat hero (label uppercase + valeur).
  // isEmpty=true → applique class is-empty (opacité 0.3) et affiche "—".
  function makeRhStat(label, value, isEmpty) {
    const item = h('div', { class: 'pdnr-rh-stat' });
    item.appendChild(h('span', { class: 'pdnr-rh-stat-label' }, label));
    const display = isEmpty ? '—' : (value || '—');
    item.appendChild(h('span', {
      class: 'pdnr-rh-stat-value' + (isEmpty ? ' is-empty' : '')
    }, display));
    return item;
  }

  // Squelette de bande V6 (icon + content + accordéon optionnel).
  // opts: { variant, icon, title, accordion, collapsed }
  // Retourne { wrap, content } pour permettre d'injecter le body après création.
  function bandFrame(opts) {
    const isAccordion = !!opts.accordion;
    const isCollapsed = isAccordion && opts.collapsed !== false;
    const variantClass = opts.variant ? ' pdnr-band-' + opts.variant : '';
    const wrap = h('section', {
      class: 'pdnr-band' + variantClass + (isCollapsed ? ' is-collapsed' : '')
    });
    if (isAccordion) wrap.setAttribute('data-accordion', 'true');

    const inner = h('div', { class: 'pdnr-band-inner' });

    const iconZone = h('div', {
      class: 'pdnr-band-icon',
      html: opts.icon || '',
      'aria-hidden': 'true'
    });
    inner.appendChild(iconZone);

    const content = h('div', { class: 'pdnr-band-content' });

    if (opts.title || isAccordion) {
      const headerEl = h('div', { class: 'pdnr-band-header' });
      if (opts.title) headerEl.appendChild(h('span', { class: 'pdnr-band-title' }, opts.title));
      if (isAccordion) headerEl.appendChild(h('span', { class: 'pdnr-band-chevron' }, '▾'));
      content.appendChild(headerEl);
    }

    inner.appendChild(content);
    wrap.appendChild(inner);

    if (isAccordion) {
      wrap.addEventListener('click', () => {
        wrap.classList.toggle('is-collapsed');
      });
    }

    return { wrap: wrap, content: content };
  }

  // Détecte les synergies actives dans la cure (base + cible + conditionnel).
  // Retourne max 3 synergies pour ne pas surcharger l'accordéon.
  // V5 — aligné catalogue V4 : tribulus_maca/vitex/calcium retirés,
  // maca/morosil/berberine/nac/glutathion ajoutés, digestion permissive sur
  // omega3 OU omega3_algue (couvre les profils vegan).
  function getActiveSynergies(payload) {
    const cure = new Set([
      ...(payload.actifs_base || []),
      ...(payload.actifs_cible || []),
      ...(payload.actifs_conditionnel || []),
    ]);

    const synergies = [];

    if (cure.has('magnesium') && cure.has('ashwagandha'))                          synergies.push('stress_magnesium_ashwagandha');
    if (cure.has('magnesium') && cure.has('melatonine'))                           synergies.push('sommeil_magnesium_melatonine');
    if (cure.has('coq10') && cure.has('vitamine_b'))                               synergies.push('energie_coq10_vitamine_b');
    if (cure.has('b12') && cure.has('omega3_algue'))                               synergies.push('vegan_b12_omega3_algue');
    if (cure.has('collagene') && cure.has('vitamine_c'))                           synergies.push('peau_collagene_vitamine_c');
    if (cure.has('vitamine_d') && cure.has('zinc') && cure.has('vitamine_c'))      synergies.push('immunite_vitamined_zinc_vitaminec');
    if (cure.has('fer_femme') && cure.has('vitamine_c'))                           synergies.push('fer_femme_vitaminec');
    if (cure.has('zinc_selenium') && cure.has('maca'))                             synergies.push('libido_homme_zinc_maca');
    if (cure.has('probiotiques') && (cure.has('omega3') || cure.has('omega3_algue'))) synergies.push('digestion_probiotiques_omega3');
    if (cure.has('magnesium') && cure.has('coq10'))                                synergies.push('sport_magnesium_coq10');
    if (cure.has('morosil') && cure.has('berberine'))                              synergies.push('poids_morosil_berberine');
    if (cure.has('nac') && cure.has('glutathion'))                                 synergies.push('nac_glutathion');

    return synergies.slice(0, 3);
  }

  // Map age range key (Q4) → label affichage hero stat (court, lisible mobile).
  function ageLabel(ageKey) {
    const map = {
      '<25':   '<25 ans',
      '25-34': '25 à 34 ans',
      '35-44': '35 à 44 ans',
      '45-54': '45 à 54 ans',
      '55+':   '55 ans et +',
    };
    return map[ageKey] || (ageKey ? ageKey + ' ans' : null);
  }

  // Map genre key → label capitalisé hero stat (Femme / Homme / Personne).
  function genreLabel(g) {
    if (g === 'femme')  return 'Femme';
    if (g === 'homme')  return 'Homme';
    if (g === 'neutre') return 'Personne';
    return null;
  }

  // Calcule la classe d'accent à appliquer sur .pdnr-page selon objectif clé.
  // Fallback: 'gold' si la clé n'est pas dans ACCENT_COLOR_MAP.
  function accentClassFor(objectifKey) {
    return 'pdnr-acc-' + (ACCENT_COLOR_MAP[objectifKey] || 'gold');
  }

  // Niveau OPTIMAL (parcours complet) ou RECOMMANDÉ (parcours partiel).
  function levelLabel(scorePersonnalisation) {
    return scorePersonnalisation === 'complet' ? 'OPTIMAL' : 'RECOMMANDÉ';
  }

  // ============================================================
  // V7 HELPERS — categoryFor / momentFor / roleFor / isObligatoire
  // ============================================================

  // Catégorie pour les section headers numérotés du bloc produits V7.
  // Fallback 'adaptogenes' si actif inconnu (paranoid — au cas où le payload
  // contient une key non mappée dans NUTRITION_CAT_OF).
  function nutritionCategoryFor(actifKey) {
    return NUTRITION_CAT_OF[actifKey] || 'adaptogenes';
  }

  // Moment pour le filter Matin/Soir/Repas/Tous.
  // Source : CATALOGUE[k].moment (string libre type "Matin avec repas",
  // "Soir au coucher", "Midi avec repas", "Matin et soir"…).
  // Heuristique :
  //   - 'matin' + 'soir' présents → 'both' (visible sur tous les filtres)
  //   - 'matin' seul → 'matin'
  //   - 'soir' / 'coucher' / 'jeun' (souvent soir) → 'soir' si pas matin
  //   - 'midi' / 'repas' / 'gras' → 'repas'
  //   - sinon 'all' (visible uniquement sur filtre Tous, jamais filtré out)
  function nutritionMomentFor(actifKey) {
    // V5 — priorité au mapping explicite MOMENT_PRISE (source unique
    // de vérité, indépendant du champ libre CATALOGUE.moment).
    const explicit = MOMENT_PRISE[actifKey];
    if (explicit && MOMENT_PRISE_LOWER[explicit]) {
      return MOMENT_PRISE_LOWER[explicit];
    }
    // Fallback heuristique sur le champ libre du catalogue.
    const data = CATALOGUE[actifKey];
    if (!data) return 'all';
    const m = (data.moment || '').toLowerCase();
    const hasMatin = m.indexOf('matin') !== -1;
    const hasSoir = m.indexOf('soir') !== -1 || m.indexOf('coucher') !== -1;
    const hasMidi = m.indexOf('midi') !== -1 || m.indexOf('repas gras') !== -1;
    if (hasMatin && hasSoir) return 'both';
    if (hasMatin) return 'matin';
    if (hasSoir) return 'soir';
    if (hasMidi) return 'repas';
    return 'all';
  }

  // Rôle (tier) pour la pill V7 + état CTA.
  // Mapping payload nutrition :
  //   actifs_base         → 'essentiel' (Inclus, non-cliquable)
  //   actifs_cible        → 'recommande' (CTA Ajouter, présélectionné via selected)
  //   actifs_conditionnel → 'recommande' aussi (idem) MAIS pill OBLIGATOIRE en plus
  //                          pour fer_femme (cf. nutritionIsObligatoire).
  function nutritionRoleFor(actifKey, payload) {
    if ((payload.actifs_base || []).indexOf(actifKey) !== -1) return 'essentiel';
    if ((payload.actifs_conditionnel || []).indexOf(actifKey) !== -1) return 'recommande';
    if ((payload.actifs_cible || []).indexOf(actifKey) !== -1) return 'recommande';
    return 'confort'; // fallback (addon ou autre)
  }

  // Pill OBLIGATOIRE rouge voile : fer_femme conditionnel = bilan ferritine
  // préalable obligatoire. Tout autre actif conditionnel n'a pas cette
  // contrainte clinique pour l'instant.
  function nutritionIsObligatoire(actifKey, payload) {
    return actifKey === 'fer_femme' &&
      (payload.actifs_conditionnel || []).indexOf(actifKey) !== -1;
  }

  // Cache image URL par handle (rempli par loadStorefrontCatalogue Phase 2d
  // ou par fallback /products/{handle}.js à la demande).
  const _imageCache = {};
  // Resolve image URL pour la card V7. Async non-bloquant : la card est
  // rendue avec placeholder bottle SVG, l'image asynchrone si dispo se
  // remplace en place via callback.
  function resolveImageUrl(handle) {
    if (!handle) return null;
    if (_imageCache[handle] !== undefined) return _imageCache[handle];
    // Si Storefront a hydraté _catalogueRemote avec featuredImage, on prend ça.
    const remote = _catalogueRemote && _catalogueRemote[handle];
    if (remote && remote.imageUrl) {
      _imageCache[handle] = remote.imageUrl;
      return remote.imageUrl;
    }
    return null;
  }
  // Async fetch /products/{handle}.js (fallback si Storefront non configuré).
  // Renvoie une Promise<string|null> avec l'URL de l'image featured.
  function fetchProductImage(handle) {
    if (!handle) return Promise.resolve(null);
    if (_imageCache[handle] !== undefined) return Promise.resolve(_imageCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!d) { _imageCache[handle] = null; return null; }
        const img = d.featured_image || (d.images && d.images[0]) || null;
        const url = typeof img === 'string' ? img : (img && img.src) || null;
        _imageCache[handle] = url;
        return url;
      })
      .catch(() => { _imageCache[handle] = null; return null; });
  }

  // V6, renderAlerts() / renderAlert() supprimés, remplacés par
  // block_vigilances() (point unique de sécurité, pattern accordéon CSS V6).

  // ----- SECTION produits (essentiels / ciblage / conditionnel) -----
  function renderSection(label, keys, role, opts) {
    opts = opts || {};
    if (!keys || keys.length === 0) {
      return h('div', { style: { display: 'none' } });
    }
    const wrap = h('section', { class: 'pdnr-section' });
    wrap.appendChild(h('div', { class: 'pdnr-section-label' },
      label + ',' + keys.length + (keys.length > 1 ? ' produits' : ' produit')));
    keys.forEach(k => wrap.appendChild(renderCard(k, role, opts)));
    return wrap;
  }

  function renderCard(key, role, opts) {
    const data = getProductData(key);
    if (!data) return h('div', null);
    opts = opts || {};
    const isLocked = !!opts.locked;
    const isChecked = isLocked ? true : !!selected[key];

    const card = h('article', {
      class: 'pdnr-card' + (isLocked ? ' is-locked' : (isChecked ? ' is-checked' : '')),
    });

    // Head : brand+nom+actif italique d'un côté, badge de l'autre
    const head = h('div', { class: 'pdnr-card-head' });
    const headLeft = h('div');
    // V5.8 — brand uniquement si Storefront résolu (vendor réel).
    if (data.brand) {
      headLeft.appendChild(h('p', { class: 'pdnr-card-brand' }, data.brand));
    }
    headLeft.appendChild(h('h3', { class: 'pdnr-card-name' }, data.title || data.nom));
    headLeft.appendChild(h('p', { class: 'pdnr-card-actif' }, data.actif));
    head.appendChild(headLeft);
    head.appendChild(renderBadge(role));
    card.appendChild(head);

    // Mention fer obligatoire dans card conditionnel
    if (opts.mention && key === 'fer_femme') {
      card.appendChild(h('div', { class: 'pdnr-card-mention-fer' }, opts.mention));
    }

    // Grille 2x2 posologie
    card.appendChild(renderPosologyGrid(data));

    // Footer : prix + bouton état
    const footer = h('div', { class: 'pdnr-card-footer' });
    // V5.8 — prix uniquement si Storefront résolu, sinon span vide pour
    // préserver le layout flex du footer.
    footer.appendChild(h('span', { class: 'pdnr-card-price' },
      (typeof data.prix === 'number') ? formatPrice(data.prix) : ''));
    footer.appendChild(renderCardButton(key, role, isLocked, isChecked));
    card.appendChild(footer);

    return card;
  }

  function renderBadge(role) {
    const labels = {
      essentiel:    'Essentiel',
      recommande:   'Recommandé',
      conditionnel: 'Conditionnel',
      synergie:     'Synergie',
      saisonnier:   'Saisonnier',
    };
    return h('span', { class: 'pdnr-badge pdnr-badge-' + role }, labels[role] || role);
  }

  function renderPosologyGrid(data) {
    const grid = h('div', { class: 'pdnr-card-grid' });
    [
      { label: 'Forme',  value: data.forme  || '—' },
      { label: 'Dosage', value: data.dosage || '—' },
      { label: 'Moment', value: data.moment || '—' },
      { label: 'Durée',  value: data.duree  || '—' },
    ].forEach(item => {
      const cell = h('div', { class: 'pdnr-card-grid-item' });
      cell.appendChild(h('span', { class: 'pdnr-card-grid-label' }, item.label));
      cell.appendChild(h('span', { class: 'pdnr-card-grid-value' }, item.value));
      grid.appendChild(cell);
    });
    return grid;
  }

  function renderCardButton(key, role, isLocked, isChecked) {
    if (isLocked) {
      return h('button', {
        class: 'pdnr-card-cta pdnr-card-cta-outline',
        type: 'button',
        disabled: 'disabled',
      }, '✓ Essentiel');
    }
    if (isChecked) {
      return h('button', {
        class: 'pdnr-card-cta',
        type: 'button',
        on: { click: () => { selected[key] = false; render(); } },
      }, '✓ Ajouté');
    }
    return h('button', {
      class: 'pdnr-card-cta pdnr-card-cta-add',
      type: 'button',
      on: { click: () => { selected[key] = true; render(); } },
    }, '+ Ajouter');
  }

  // V5 Sprint A — renderPratique() supprimé. Le bloc « Votre protocole en
  // pratique » est remplacé par la bande « Réussir votre cure » conseil
  // pharmacienne dans Sprint C.

  // V5 Sprint B — renderAddons() et renderAddonCard() supprimés. Les
  // add-ons sont désormais rendus dans la section CONFORT de
  // renderProductsBlock via renderProductCardV7(key, 'confort').

  // V5.3 — Upsell mini-catalogue inline. Fetch 4 produits depuis la
  // collection parapharmacie (ou sous-collection peau si objectif=peau_phaneres)
  // et les rend comme cartes ajoutables au panier directement. Pas de CTA
  // sortant — l'utilisateur reste sur la page résultats.
  function renderUpsell() {
    const isPeau = bilan && bilan.objectif_principal_key === 'peau_phaneres';
    const eyebrow = isPeau ? 'ET VOS SOINS ?' : 'POUR ALLER PLUS LOIN';
    // Titre cohérent avec le conditionnement sur l'objectif de la cure :
    // les produits remontés viennent de /collections/cure-{objectif-slug}
    // (cf. loadUpsellProducts), donc liés au profil clinique de la cure.
    const title = isPeau
      ? 'Complétez votre cure avec nos soins peau.'
      : 'Sélectionnés en lien avec votre cure.';

    const wrap = h('section', { class: 'pdnr-block-upsell' });
    wrap.appendChild(h('p', { class: 'pdnr-block-upsell-eyebrow' }, eyebrow));
    wrap.appendChild(h('h2', { class: 'pdnr-block-upsell-title' }, title));

    // Fallback statique : si fetch terminé et collection vide (cas en
    // période de transition catalogue), afficher un sous-titre + CTA
    // générique vers /collections/parapharmacie au lieu de masquer.
    // Quand Bilikiss peuple la collection, ça bascule automatiquement
    // sur les vraies cartes produit au prochain render.
    if (_upsellFetched && (!_upsellProducts || _upsellProducts.length === 0)) {
      wrap.appendChild(h('p', { class: 'pdnr-block-upsell-subtitle' },
        'Découvrez notre sélection de compléments et soins dans nos collections.'));
      wrap.appendChild(h('a', {
        class: 'pdnr-block-upsell-cta',
        href: '/collections/nav-complements-beaute-peau',
      }, isPeau ? 'Voir nos soins peau →' : 'Voir nos compléments →'));
      return wrap;
    }

    // Grid de produits. Si fetch pas encore terminé, afficher 4 skeletons
    // qui se remplaceront au re-render après hydratation.
    const grid = h('div', { class: 'pdnr-upsell-grid' });
    if (!_upsellFetched) {
      for (let i = 0; i < 4; i++) {
        grid.appendChild(h('div', { class: 'pdnr-upsell-card pdnr-upsell-card-skeleton' }));
      }
    } else {
      _upsellProducts.slice(0, 4).forEach(p => {
        grid.appendChild(renderUpsellCard(p));
      });
    }
    wrap.appendChild(grid);
    return wrap;
  }

  // V5.3 — Carte produit upsell. Bouton + Ajouter pousse directement au
  // cart Shopify via addUpsellToCart(variantId).
  function renderUpsellCard(product) {
    const card = h('article', { class: 'pdnr-upsell-card' });
    const href = product.handle ? '/products/' + product.handle : null;

    // Image (lien produit en nouvelle fenêtre pour ne pas perdre la page résultats).
    const imgEl = h('div', { class: 'pdnr-upsell-card-image' });
    if (product.image) {
      imgEl.appendChild(h('img', {
        src: product.image, alt: product.title || '', loading: 'lazy',
      }));
    } else {
      imgEl.appendChild(h('span', { class: 'pdnr-upsell-card-image-placeholder' }, '◯'));
    }
    if (href) {
      const a = h('a', { href: href, target: '_blank', rel: 'noopener' });
      a.appendChild(imgEl);
      card.appendChild(a);
    } else {
      card.appendChild(imgEl);
    }

    // Marque + nom
    if (product.vendor) {
      card.appendChild(h('p', { class: 'pdnr-upsell-card-brand' }, product.vendor));
    }
    card.appendChild(h('h3', { class: 'pdnr-upsell-card-name' }, product.title || ''));

    // Prix + bouton
    const foot = h('div', { class: 'pdnr-upsell-card-foot' });
    if (typeof product.price === 'number') {
      foot.appendChild(h('span', { class: 'pdnr-upsell-card-price' }, formatPrice(product.price)));
    }
    const btn = h('button', {
      class: 'pdnr-upsell-card-cta',
      type: 'button',
      disabled: product.variantId ? null : 'disabled',
    }, '+ Ajouter');
    btn.addEventListener('click', () => addUpsellToCart(product));
    foot.appendChild(btn);
    card.appendChild(foot);

    return card;
  }

  // V5.3 — Fetch async des produits upsell. Cible la sous-collection peau
  // si objectif=peau_phaneres, sinon parapharmacie globale. Re-render
  // unique au retour du fetch pour remplacer les skeletons.
  // V5.8 — Mapping objectif quiz nutrition → collection Shopify Headless.
  // Les collections `nav-complements-*` sont peuplées et indexent par
  // grand domaine. Pas de collection « parapharmacie » globale côté store —
  // on retombe sur `nav-complements-beaute-peau` (la mieux fournie) si
  // l'objectif n'a pas de mapping direct.
  const OBJECTIF_TO_COLLECTION = {
    beaute_peau:         'nav-complements-beaute-peau',
    peau_phaneres:       'nav-complements-beaute-peau',
    energie_vitalite:    'nav-complements-energie-vitalite',
    energie:             'nav-complements-energie-vitalite',
    vitalite_femme:      'nav-complements-energie-vitalite',
    vitalite_homme:      'nav-complements-energie-vitalite',
    vitalite_neutre:     'nav-complements-energie-vitalite',
    sport:               'nav-complements-energie-vitalite',
    sommeil:             'nav-complements-sommeil',
    sommeil_recup:       'nav-complements-sommeil',
    stress_chronique:    'nav-complements-sommeil',
    hormonal_cycle:      'nav-complements-equilibre-hormonal',
    hormonal:            'nav-complements-equilibre-hormonal',
    libido_femme:        'nav-complements-bienetre-feminin',
    bien_etre_femme:     'nav-complements-bienetre-feminin',
    projet_grossesse:    'nav-complements-grossesse',
    cheveux_ongles:      'nav-complements-cheveux-ongles',
    beaute_cheveux:      'nav-complements-cheveux-ongles',
  };

  // V5.8 — Upsell via Storefront API (GraphQL). Plus robuste que /collections/
  // X/products.json qui peut ne pas remonter tous les produits Headless
  // selon la config du canal. Une seule query, mapping objectif → collection,
  // fallback gracieux sur les compléments beauté peau (collection la mieux
  // fournie).
  function loadUpsellProducts() {
    if (_upsellFetched) return Promise.resolve(_upsellProducts);
    const objectif = bilan && bilan.objectif_principal_key;
    const primaryHandle = (objectif && OBJECTIF_TO_COLLECTION[objectif])
      || 'nav-complements-beaute-peau';
    const fallbackHandle = 'nav-complements-beaute-peau';

    const token = window.PARADERMIA_NUTRITION_STOREFRONT_TOKEN;
    const shop = window.Shopify && window.Shopify.shop;
    if (!token || !shop) {
      _upsellFetched = true;
      _upsellProducts = [];
      if (app && app.root) render();
      return Promise.resolve(_upsellProducts);
    }

    const buildQuery = (handle) => ({
      query: `query upsell($h: String!) {
        collection(handle: $h) {
          products(first: 4) {
            edges { node {
              handle title vendor
              featuredImage { url }
              variants(first: 1) { edges { node { id price { amount } } } }
            } }
          }
        }
      }`,
      variables: { h: handle },
    });

    const fetchCollection = (handle) => fetch('https://' + shop + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify(buildQuery(handle)),
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => (d && d.data && d.data.collection && d.data.collection.products && d.data.collection.products.edges) || null)
      .catch(() => null);

    return fetchCollection(primaryHandle)
      .then(edges => {
        if (edges && edges.length > 0) return edges;
        if (primaryHandle !== fallbackHandle) return fetchCollection(fallbackHandle);
        return [];
      })
      .then(edges => {
        _upsellFetched = true;
        _upsellProducts = (edges || []).map(e => {
          const n = e.node;
          const v = n.variants && n.variants.edges[0] && n.variants.edges[0].node;
          return {
            handle: n.handle,
            title: n.title,
            vendor: n.vendor || '',
            image: n.featuredImage && n.featuredImage.url,
            price: v ? parseFloat(v.price.amount) : null,
            variantId: v ? parseInt(v.id.replace(/\D/g, ''), 10) : null,
          };
        });
        console.log('[Bilan Résultats] Upsell (' + primaryHandle + ') :',
          _upsellProducts.length, 'produits',
          _upsellProducts.map(p => p.handle));
        if (app && app.root) render();
        return _upsellProducts;
      });
  }

  // V5.3 — Ajout au panier d'un produit upsell. Toast + ne change pas
  // l'état de la page résultats (rester sur la page).
  function addUpsellToCart(product) {
    if (!product || !product.variantId) {
      showToast('Produit indisponible.');
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1 }] }),
    })
      .then(r => r.ok ? r.json() : Promise.reject('Cart add failed'))
      .then(() => {
        showToast((product.title || 'Produit') + ' ajouté ✓', '/cart');
      })
      .catch(err => {
        console.error('[Bilan Résultats] Upsell cart failed :', err);
        showToast('Erreur lors de l\'ajout au panier.');
      });
  }

  // V5 Sprint C — renderTeaser() supprimé. La notice est désormais rendue
  // comme une carte produit dans renderProductsBlock après la section CONFORT
  // (renderNoticeCard) et dans le récap final (ligne dédiée).

  // ----- RÉCAP PANIER -----
  // V5.2 — Récap final aligné sur le pattern quiz peau : deux blocs distincts.
  //   Bloc A « Votre protocole complet » : sections accordéon par role
  //     (Essentiels / Recommandés / Confort) avec checkboxes décochables.
  //     Pas de prix sur les lignes — juste badge catégorie + tiret.
  //   Bloc B « TOTAL PROTOCOLE / Cure {Objectif} {Optimale|Recommandée} » :
  //     titre dynamique avec mot médian italique accent, sous-titre
  //     « — pour vous, {firstName} — », CTA panier, liens, réassurance.
  function renderRecap() {
    const wrap = h('div', { class: 'pdnr-recap-stack' });
    wrap.appendChild(renderRecapProtocole());
    wrap.appendChild(renderRecapTotal());
    return wrap;
  }

  // V5.2 — Bloc A : « Votre protocole complet ». Sections accordéon.
  function renderRecapProtocole() {
    const wrap = h('section', { class: 'pdnr-recap pdnr-recap-protocole pd-bande' });
    wrap.appendChild(h('h2', { class: 'pdnr-recap-protocole-title' },
      'Votre protocole complet'));
    wrap.appendChild(h('p', { class: 'pdnr-recap-protocole-subtitle' },
      'Ajustez votre sélection puis ajoutez le tout à votre panier.'));

    // Accordéon « UN PROTOCOLE COHÉRENT » — pédagogie cure, replié.
    wrap.appendChild(renderRecapAccordeon(
      'UN PROTOCOLE COHÉRENT',
      null,
      'Chaque actif a été sélectionné pour répondre à un besoin précis de votre profil. Ensemble, ils forment une synergie cliniquement cohérente — pas une accumulation aléatoire. Vous pouvez ajuster votre sélection ci-dessous.',
      true
    ));

    // Helper : rend une section accordéon role avec lignes checkbox.
    function renderRoleAccordeon(categorieKey, keys, withAlerte, openByDefault) {
      if (!keys || keys.length === 0) return null;
      const count = keys.length;
      const labelHeader = CATEGORIE_LABELS[categorieKey] + ' — ' + count +
        ' PRODUIT' + (count > 1 ? 'S' : '');

      // Construit le body (toutes les lignes).
      const body = h('div', { class: 'pdnr-recap-accordeon-body' });
      keys.forEach(k => {
        const d = getProductData(k);
        if (!d) return;
        const isChecked = !!selected[k];
        const line = h('div', {
          class: 'pdnr-recap-line' + (isChecked ? ' is-checked' : ''),
        });
        const cb = h('input', {
          type: 'checkbox',
          class: 'pdnr-recap-checkbox',
          checked: isChecked ? 'checked' : null,
          'aria-label': 'Inclure ' + d.nom + ' dans la cure',
        });
        cb.addEventListener('change', () => {
          selected[k] = cb.checked;
          render();
        });
        line.appendChild(cb);

        const info = h('div', { class: 'pdnr-recap-line-info' });
        if (d.brand) {
          info.appendChild(h('p', { class: 'pdnr-recap-line-brand' }, d.brand));
        }
        info.appendChild(h('p', { class: 'pdnr-recap-line-name' }, d.title || d.nom));
        line.appendChild(info);

        line.appendChild(h('span', {
          class: 'pdnr-recap-line-badge pdnr-recap-line-badge--' + categorieKey,
        }, CATEGORIE_LABELS[categorieKey].slice(0, -1))); // ESSENTIELS → ESSENTIEL
        // Prix unitaire — Storefront en priorité, fallback prix_indicatif
        // du CATALOGUE local si le token Storefront n'est pas résolu.
        const linePrice = (d.prix != null) ? d.prix : d.prix_indicatif;
        line.appendChild(h('span', { class: 'pdnr-recap-line-price' },
          (typeof linePrice === 'number') ? formatPrice(linePrice) : '—'));

        if (withAlerte) {
          line.appendChild(h('p', {
            class: 'pd-uncheck-alert',
            style: isChecked ? 'display:none' : '',
          }, 'Ce complément est la recommandation prioritaire pour votre profil.'));
        }
        body.appendChild(line);
      });

      return renderRecapAccordeon(labelHeader, null, body, !openByDefault);
    }

    const essentielsKeys = bilan.actifs_base || [];
    const recommandesKeys = [].concat(
      bilan.actifs_cible || [],
      bilan.actifs_conditionnel || []
    );
    const confortKeys = (bilan.actifs_addon || []).map(a =>
      typeof a === 'string' ? a : (a && a.key)).filter(Boolean);

    // Essentiels ouverts par défaut (visible immédiatement), Recommandés
    // et Confort repliés (l'utilisateur déplie s'il veut ajuster).
    const accEss = renderRoleAccordeon('essentiels', essentielsKeys, true, true);
    if (accEss) wrap.appendChild(accEss);
    const accRec = renderRoleAccordeon('recommandes', recommandesKeys, false, false);
    if (accRec) wrap.appendChild(accRec);
    const accConf = renderRoleAccordeon('confort', confortKeys, false, false);
    if (accConf) wrap.appendChild(accConf);

    return wrap;
  }

  // V5.2 — Helper accordéon récap.
  //   labelHeader : string label uppercase
  //   counter : null ou string (compteur ex "6 PRODUITS")
  //   bodyContent : string (rendu en p) OU élément DOM (rendu tel quel)
  //   collapsed : bool, vrai = replié par défaut
  function renderRecapAccordeon(labelHeader, counter, bodyContent, collapsed) {
    const acc = h('div', {
      class: 'pdnr-recap-accordeon' + (collapsed ? ' is-collapsed' : ''),
    });
    const header = h('button', {
      class: 'pdnr-recap-accordeon-header',
      type: 'button',
      'aria-expanded': collapsed ? 'false' : 'true',
    });
    header.appendChild(h('span', { class: 'pdnr-recap-accordeon-label' }, labelHeader));
    if (counter) {
      header.appendChild(h('span', { class: 'pdnr-recap-accordeon-count' }, counter));
    }
    header.appendChild(h('span', { class: 'pdnr-recap-accordeon-chevron' }, '⌄'));
    acc.appendChild(header);

    let body;
    if (typeof bodyContent === 'string') {
      body = h('div', { class: 'pdnr-recap-accordeon-body' });
      body.appendChild(h('p', { class: 'pdnr-recap-accordeon-text' }, bodyContent));
    } else {
      body = bodyContent;
    }
    acc.appendChild(body);

    header.addEventListener('click', () => {
      const wasCollapsed = acc.classList.contains('is-collapsed');
      acc.classList.toggle('is-collapsed');
      header.setAttribute('aria-expanded', wasCollapsed ? 'true' : 'false');
    });

    return acc;
  }

  // V5.2 — Bloc B : « TOTAL PROTOCOLE / Cure {Objectif} {Niveau} ».
  // Titre dynamique avec mot médian objectif en italique accent or.
  // Total estimé « Calculé au panier » (pas de prix figés côté UI).
  // Stub renderRecapTotal — la fonction historique renderRecap reste
  // utilisée par render(). On la garde mais on l'aiguille vers les nouveaux
  // blocs via le helper interne. La signature ci-dessous est utilisée par
  // le wrapper renderRecap V5.2.
  function renderRecapTotal() {
    const wrap = h('section', { class: 'pdnr-recap pdnr-recap-total-block pd-bande' });

    // Eyebrow + counter à droite
    const head = h('div', { class: 'pdnr-recap-total-head' });
    head.appendChild(h('span', { class: 'pdnr-recap-total-eyebrow' }, 'TOTAL PROTOCOLE'));
    const allKeysAll = [].concat(
      bilan.actifs_base || [],
      bilan.actifs_cible || [],
      bilan.actifs_conditionnel || [],
      (bilan.actifs_addon || []).map(a => typeof a === 'string' ? a : (a && a.key)).filter(Boolean)
    );
    const selectedCount = allKeysAll.filter(k => selected[k]).length;
    head.appendChild(h('span', { class: 'pdnr-recap-total-counter' },
      selectedCount + (selectedCount > 1 ? ' produits' : ' produit')));
    wrap.appendChild(head);

    // Titre « Cure {Objectif} {Niveau} » avec mot médian italique accent.
    const niveau = bilan.score_personnalisation === 'complet' ? 'Optimale' : 'Recommandée';
    const objectifLabel = OBJECTIF_LABELS[bilan.objectif_principal_key]
      || bilan.objectif_principal
      || 'Personnalisée';

    const titleEl = h('h2', { class: 'pdnr-recap-total-title' });
    titleEl.appendChild(document.createTextNode('Cure '));
    titleEl.appendChild(h('em', { class: 'pdnr-recap-total-title-accent' }, objectifLabel));
    titleEl.appendChild(document.createTextNode(' ' + niveau));
    wrap.appendChild(titleEl);

    // Sous-titre « — pour vous, {firstName} — »
    const meta = bilan._meta || {};
    const firstName = (meta.firstName && typeof meta.firstName === 'string')
      ? meta.firstName.trim() : '';
    const subtitleText = firstName
      ? '— pour vous, ' + firstName + ' —'
      : '— pour vous —';
    wrap.appendChild(h('p', { class: 'pdnr-recap-total-subtitle' }, subtitleText));

    // V5.8 — Total dynamique calculé UNIQUEMENT sur les produits commandables
    // (variantId Storefront présent). Les actifs cliniquement recommandés
    // mais sans produit Headless référencé sont exclus du total et marqués
    // « Bientôt » dans la carte — on ne facture pas du vent.
    const allKeys = allKeysAll;
    const selectedKeys = allKeys.filter(k => selected[k]);
    const orderableKeys = selectedKeys.filter(k => {
      const d = getProductData(k);
      return d && d.variantId;
    });
    let totalEstime = 0;
    orderableKeys.forEach(k => {
      const d = getProductData(k);
      if (d && typeof d.prix === 'number') totalEstime += d.prix;
    });
    const totalLabel = totalEstime > 0
      ? formatPrice(totalEstime)
      : 'À venir';

    const totalRow = h('div', { class: 'pdnr-recap-total-row' });
    totalRow.appendChild(h('span', { class: 'pdnr-recap-total-row-label' }, 'TOTAL ESTIMÉ'));
    totalRow.appendChild(h('span', { class: 'pdnr-recap-total-row-value' }, totalLabel));
    wrap.appendChild(totalRow);

    // V5.8 — mention nb d'actifs « Bientôt disponibles » si l'écart existe.
    // Évite de laisser croire que tout le protocole est commandable.
    const soonCount = selectedKeys.length - orderableKeys.length;
    if (soonCount > 0) {
      wrap.appendChild(h('p', {
        class: 'pdnr-recap-total-soon',
      }, soonCount + (soonCount > 1 ? ' actifs' : ' actif')
         + ' de votre protocole arrive' + (soonCount > 1 ? 'nt' : '')
         + ' prochainement à notre catalogue.'));
    }

    // Bouton AJOUTER AU PANIER — désactivé si rien de commandable.
    const addCta = h('button', {
      class: 'pdnr-recap-add-cart',
      type: 'button',
      disabled: orderableKeys.length === 0 ? 'disabled' : null,
      on: { click: () => addToCart(orderableKeys) },
    }, orderableKeys.length === 0
        ? 'CATALOGUE EN COURS DE FINALISATION'
        : 'AJOUTER AU PANIER →');
    wrap.appendChild(addCta);

    // 2 liens texte côte à côte
    const links = h('div', { class: 'pdnr-recap-links' });
    const linkEmail = h('button', {
      class: 'pdnr-recap-link',
      type: 'button',
      on: { click: downloadNotice },
    }, 'Télécharger ma notice (PDF)');
    const linkRestart = h('a', {
      class: 'pdnr-recap-link',
      href: (typeof window !== 'undefined' && window.PARADERMIA_NUTRITION_QUIZ_URL) || '/pages/quiz-nutrition',
    }, 'Recommencer mon analyse');
    links.appendChild(linkEmail);
    links.appendChild(linkRestart);
    wrap.appendChild(links);

    // Email input caché derrière le bouton (gardé pour Klaviyo si user clique).
    // Display none par défaut, le bouton email pourrait l'afficher en sprint suivant.
    const emailWrap = h('div', { class: 'pdnr-recap-email-hidden', style: 'display:none' });
    emailWrap.appendChild(h('input', {
      type: 'email',
      class: 'pdnr-recap-email-input',
      placeholder: 'votre@email.com',
      value: _emailValue,
      on: { input: (e) => { _emailValue = e.target.value; } },
    }));
    wrap.appendChild(emailWrap);

    // Réassurance ligne horizontale — V5.4 SVG minimalistes inline.
    const reass = h('div', { class: 'pdnr-recap-reass' });
    [
      { icon: SVG.truck,    label: 'Point relais offert dès 39 €' },
      { icon: SVG.return_,  label: 'Retours gratuits' },
      { icon: SVG.bookmark, label: 'Sauvegardé dans votre espace membre' },
      { icon: SVG.lock,     label: 'Paiement sécurisé' },
    ].forEach(item => {
      const span = h('span', { class: 'pdnr-recap-reass-item' });
      span.appendChild(h('span', { class: 'pdnr-recap-reass-icon', html: item.icon }));
      span.appendChild(document.createTextNode(' ' + item.label));
      reass.appendChild(span);
    });
    wrap.appendChild(reass);

    return wrap;
  }

  // V5.1 — Ancienne fonction renderRecap, supprimée au profit du wrapper
  // V5.2 ci-dessus qui délègue à renderRecapProtocole + renderRecapTotal.
  // Stub conservé pour la transition (jamais appelé directement).
  function __renderRecapV51_REMOVED__() {
    const wrap = h('section', { class: 'pdnr-recap pd-bande' });

    // --- Titre dynamique : « Cure {Objectif} {Optimale|Recommandée} » ---
    const niveau = bilan.score_personnalisation === 'complet' ? 'Optimale' : 'Recommandée';
    const objectifLabel = OBJECTIF_LABELS[bilan.objectif_principal_key]
      || bilan.objectif_principal
      || 'Personnalisée';
    const titleEl = h('h3', { class: 'pdnr-recap-title' },
      'Cure ' + objectifLabel + ' ' + niveau);
    wrap.appendChild(titleEl);

    // --- Sous-titre : « — pour vous, {firstName} — » ou « — pour vous — » ---
    const meta = bilan._meta || {};
    const firstName = (meta.firstName && typeof meta.firstName === 'string')
      ? meta.firstName.trim() : '';
    const subtitleText = firstName
      ? '— pour vous, ' + firstName + ' —'
      : '— pour vous —';
    wrap.appendChild(h('p', { class: 'pdnr-recap-subtitle' }, subtitleText));

    // --- Helper : rend une section role complète avec checkboxes ---
    // `withAlerte` (true pour essentiels) ajoute le slot alerte décoché.
    function renderRecapSection(categorieKey, keys, withAlerte) {
      if (!keys || keys.length === 0) return null;
      const section = h('div', {
        class: 'pdnr-recap-section pdnr-recap-section--' + categorieKey,
      });
      const head = h('div', { class: 'pdnr-recap-section-head' });
      head.appendChild(h('span', { class: 'pdnr-recap-section-label' },
        CATEGORIE_LABELS[categorieKey]));
      head.appendChild(h('span', { class: 'pdnr-recap-section-count' },
        '— ' + keys.length + ' PRODUIT' + (keys.length > 1 ? 'S' : '')));
      section.appendChild(head);

      keys.forEach(k => {
        const d = getProductData(k);
        if (!d) return;
        const isChecked = !!selected[k];
        const line = h('div', {
          class: 'pdnr-recap-line' + (isChecked ? ' is-checked' : ''),
        });
        // Checkbox custom (input réel + label visuel).
        const cb = h('input', {
          type: 'checkbox',
          class: 'pdnr-recap-checkbox',
          checked: isChecked ? 'checked' : null,
          'aria-label': 'Inclure ' + d.nom + ' dans la cure',
        });
        cb.addEventListener('change', () => {
          selected[k] = cb.checked;
          render(); // re-render full pour total + sync cartes produit
        });
        line.appendChild(cb);
        line.appendChild(h('span', { class: 'pdnr-recap-line-name' }, d.title || d.nom));
        line.appendChild(h('span', { class: 'pdnr-recap-line-tiret' }, '—'));
        // V5.8 — prix uniquement si Storefront résolu (d.prix), sinon tiret.
        line.appendChild(h('span', { class: 'pdnr-recap-line-price' },
          (typeof d.prix === 'number') ? formatPrice(d.prix) : '—'));
        if (withAlerte) {
          // Slot alerte décoché essentiel — affiché si décoché par l'utilisateur.
          line.appendChild(h('p', {
            class: 'pd-uncheck-alert',
            style: isChecked ? 'display:none' : '',
          }, isChecked ? '' : 'Ce complément est la recommandation prioritaire pour votre profil.'));
        }
        section.appendChild(line);
      });
      return section;
    }

    const essentielsKeys = bilan.actifs_base || [];
    const recommandesKeys = [].concat(
      bilan.actifs_cible || [],
      bilan.actifs_conditionnel || []
    );
    const confortKeys = (bilan.actifs_addon || []).map(a =>
      typeof a === 'string' ? a : (a && a.key)).filter(Boolean);

    const sEssentiels = renderRecapSection('essentiels', essentielsKeys, true);
    if (sEssentiels) wrap.appendChild(sEssentiels);
    const sRecommandes = renderRecapSection('recommandes', recommandesKeys, false);
    if (sRecommandes) wrap.appendChild(sRecommandes);
    const sConfort = renderRecapSection('confort', confortKeys, false);
    if (sConfort) wrap.appendChild(sConfort);

    // --- Ligne notice : OFFERT or, non décochable, badge INCLUS ---
    const notice = h('div', { class: 'pdnr-recap-line pdnr-recap-notice-line is-checked' });
    notice.appendChild(h('span', { class: 'pdnr-recap-notice-icon', html: SVG.documentSmall }));
    notice.appendChild(h('span', { class: 'pdnr-recap-line-name' }, 'Notice de cure personnalisée'));
    notice.appendChild(h('span', { class: 'pdnr-recap-line-tiret' }, '—'));
    notice.appendChild(h('span', { class: 'pdnr-recap-notice-offert' }, 'OFFERT'));
    wrap.appendChild(notice);

    // --- Total + nb produits sélectionnés ---
    const allKeys = [].concat(essentielsKeys, recommandesKeys, confortKeys);
    const selectedKeys = allKeys.filter(k => selected[k]);
    let total = 0;
    selectedKeys.forEach(k => {
      const d = getProductData(k);
      if (d && typeof d.prix === 'number') total += d.prix;
    });

    const tot = h('div', { class: 'pdnr-recap-total' });
    const totLabel = h('div', { class: 'pdnr-recap-total-left' });
    totLabel.appendChild(h('span', { class: 'pdnr-recap-total-label' }, 'TOTAL CURE'));
    totLabel.appendChild(h('span', { class: 'pdnr-recap-total-count' },
      selectedKeys.length + (selectedKeys.length > 1 ? ' produits sélectionnés' : ' produit sélectionné')));
    tot.appendChild(totLabel);
    tot.appendChild(h('span', { class: 'pdnr-recap-total-value' }, formatPrice(total)));
    wrap.appendChild(tot);

    // --- Email input (récupéré pour Klaviyo) ---
    const emailWrap = h('div', { class: 'pdnr-recap-email' });
    emailWrap.appendChild(h('input', {
      type: 'email',
      class: 'pdnr-recap-email-input',
      placeholder: 'votre@email.com',
      value: _emailValue,
      on: { input: (e) => { _emailValue = e.target.value; } },
    }));
    wrap.appendChild(emailWrap);

    // --- 3 CTAs dans l'ordre spec : Ajouter panier → Email → Recommencer ---
    const ctas = h('div', { class: 'pdnr-recap-ctas' });
    const ctaCart = h('button', {
      class: 'pdnr-recap-cta pdnr-recap-cta-primary',
      type: 'button',
      disabled: selectedKeys.length === 0 ? 'disabled' : null,
      on: { click: () => addToCart(selectedKeys) },
    }, 'AJOUTER AU PANIER →');
    ctas.appendChild(ctaCart);

    const ctaEmail = h('button', {
      class: 'pdnr-recap-cta pdnr-recap-cta-link',
      type: 'button',
      on: { click: downloadNotice },
    }, 'Télécharger ma notice (PDF)');
    ctas.appendChild(ctaEmail);

    const ctaRestart = h('a', {
      class: 'pdnr-recap-cta pdnr-recap-cta-link',
      href: (typeof window !== 'undefined' && window.PARADERMIA_NUTRITION_QUIZ_URL) || '/pages/quiz-nutrition',
    }, 'Recommencer mon bilan');
    ctas.appendChild(ctaRestart);

    wrap.appendChild(ctas);

    // --- Réassurance ligne finale ---
    const reass = h('div', { class: 'pdnr-recap-reass' });
    [
      '🚚 Livraison offerte dès 60 €',
      '↩ Retours gratuits',
      '🔖 Sauvegardé dans votre espace membre',
      '🔒 Paiement sécurisé',
    ].forEach(txt => {
      reass.appendChild(h('span', { class: 'pdnr-recap-reass-item' }, txt));
    });
    wrap.appendChild(reass);

    return wrap;
  }

  // ----- MENTION LÉGALE -----
  function renderMentionLegale() {
    return h('p', { class: 'pdnr-mention-legale' }, MENTION_LEGALE_TEXT);
  }

  // ============================================================
  // CART + KLAVIYO
  // ============================================================
  function addToCart(selectedKeys) {
    if (selectedKeys.length === 0) return;
    Promise.all(selectedKeys.map(k => lookupByActifKey(k)))
      .then(variants => {
        const items = variants.filter(v => v && v.variantId).map(v => ({
          id: v.variantId, quantity: 1,
        }));
        if (items.length === 0) {
          showToast('Impossible de récupérer les produits.');
          return;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        }).then(r => {
          if (!r.ok) throw new Error('cart/add failed');
          showToast(items.length + ' produits ajoutés ✓ Voir mon panier →', '/cart');
        });
      })
      .catch(err => {
        console.error('[Bilan Résultats] Erreur panier :', err);
        showToast('Erreur lors de l\'ajout au panier.');
      });
  }

  // V5.8 — Résolution par clé d'actif (vitamine_d, magnesium…) 100% Storefront.
  // Le fallback /products/{handle}.js a été retiré car les handles locaux
  // du CATALOGUE sont obsolètes (anciens fournisseurs purgés). Si l'actif
  // n'a pas de produit Headless tagué `complement_{actif_key}`, retour null
  // → la carte se rend en mode éducatif (pas de bouton panier).
  function lookupByActifKey(actifKey) {
    if (!actifKey) return Promise.resolve(null);
    const cached = _catalogueRemote && _catalogueRemote[actifKey];
    if (cached && cached.variantId) return Promise.resolve(cached);
    return Promise.resolve(null);
  }

  // V5 — détermine si la sélection courante constitue une « cure » au sens
  // Klaviyo (vs achat à l'unité). Seuil exposé par le payload algo via
  // `cure_threshold` (V5, défaut 2). Fonction pure, exportée pour tests.
  function computeIsCure(selectedCount, cureThreshold) {
    const threshold = typeof cureThreshold === 'number' && cureThreshold > 0
      ? cureThreshold : 2;
    return selectedCount >= threshold;
  }

  // 2026-10-06 — Téléchargement direct de la notice de cure (PDF), sans compte.
  // Moteur quiz-nutrition-notice.js chargé par bilan-nutrition-resultats.liquid.
  function downloadNotice() {
    if (!bilan) { showToast('Aucun bilan à télécharger.'); return; }
    var N = window.ParaDermiaNutritionNotice;
    if (!N || typeof N.download !== 'function') { showToast('Génération indisponible pour le moment. Rechargez la page.'); return; }
    try { N.download(bilan, CATALOGUE, { firstName: ((bilan._meta || {}).firstName || '').trim() }); } catch (e) { console.error('[Bilan Résultats] notice', e); }
    try { window._learnq = window._learnq || []; window._learnq.push(['track', 'Bilan Nutrition Notice Téléchargée', { objectif: bilan.objectif_principal_key || null }]); } catch (_) {}
    showToast('Votre notice PDF se prépare ✓');
  }

  // ============================================================
  // E-MAIL « VOTRE CURE » — event Klaviyo une fois par bilan
  // ============================================================
  // Envoyé après résolution Storefront pour porter les VRAIS produits
  // (marque, prix, lien, image). Pas de dose (celle du produit fait foi,
  // voir l'étiquette) ni de texte « pourquoi » (allégations).
  function pushProtocole() {
    try {
      if (!bilan || !bilan._meta || !bilan._meta.email) return;
      var flag = 'pdn_proto_sent_' + (bilan._generated_at || '');
      if (sessionStorage.getItem(flag)) return;
      var UTM = 'utm_source=klaviyo&utm_medium=email&utm_campaign=protocole_nutrition';
      function card(key, role, raison) {
        var d = getProductData(key); if (!d) return null;
        return {
          actif: d.nom, role: role, raison: raison || null,
          nom: d.title || null, marque: d.brand || null,
          prix: typeof d.prix === 'number' ? d.prix.toFixed(2).replace('.', ',') + ' €' : null,
          url: d.handle ? 'https://paradermia.com/products/' + d.handle + '?' + UTM : null,
          image: d.imageUrl ? d.imageUrl + (d.imageUrl.indexOf('?') > -1 ? '&' : '?') + 'width=240' : null,
          moment: d.moment || null, duree: d.duree || null,
          variantId: d.variantId || null
        };
      }
      var cure = [];
      (bilan.actifs_base || []).forEach(function (k) { var c = card(k, 'base'); if (c) cure.push(c); });
      (bilan.actifs_cible || []).forEach(function (k) { var c = card(k, 'cible'); if (c) cure.push(c); });
      var fer = (bilan.actifs_conditionnel || []).indexOf('fer_femme') !== -1 ? card('fer_femme', 'conditionnel') : null;
      var confort = (bilan.actifs_addon || []).map(function (a) { return card(a.key, 'confort', a.justification); }).filter(Boolean);
      var ids = cure.filter(function (c) { return c.variantId; }).map(function (c) { return c.variantId + ':1'; });
      var props = {
        protocole_prenom: bilan._meta.firstName || null,
        protocole_objectif: bilan.objectif_principal || null,
        protocole_objectif_2: bilan.objectif_secondaire || null,
        protocole_niveau: bilan.score_personnalisation || null,
        protocole_cure: cure,
        protocole_fer: fer,
        protocole_ecartes: (bilan.ci_detectees || []).length > 0,
        protocole_depuis_peau: !!bilan.depuis_quiz_peau,
        protocole_confort: confort,
        protocole_panier: ids.length ? 'https://paradermia.com/cart/' + ids.join(',') + '?attributes[from_bilan_nutrition]=true&attributes[_pd_source]=email_protocole&' + UTM : null,
        protocole_lien_bilan: 'https://paradermia.com/pages/quiz-nutrition?' + UTM
      };
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: bilan._meta.email, $first_name: bilan._meta.firstName || undefined }]);
      window._learnq.push(['track', 'Bilan Nutrition Protocole', props]);
      sessionStorage.setItem(flag, '1');
    } catch (e) { console.warn('[Bilan Résultats] protocole e-mail', e); }
  }

  function sendEmail() {
    const email = (_emailValue || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showToast('Email invalide.');
      return;
    }
    try {
      window._learnq = window._learnq || [];
      const selection_finale = Object.keys(selected).filter(k => selected[k]);
      // V5 — flag cure vs unité pour segmentation Klaviyo + déclenchement
      // avantage cure front. Seuil lu depuis payload.cure_threshold (défaut 2).
      const is_cure = computeIsCure(
        selection_finale.length,
        bilan && bilan.cure_threshold
      );
      const props = Object.assign({}, bilan, {
        selection_finale: selection_finale,
        is_cure: is_cure,
      });
      window._learnq.push(['identify', { $email: email }]);
      window._learnq.push(['track', 'Bilan Micro-Nutrition Sélection Finale', props]);
      console.log('[Bilan Résultats] Klaviyo envoyé :', props);
      showToast('Sélection envoyée à votre email ✓');
    } catch (e) {
      console.error('[Bilan Résultats] Klaviyo failed :', e);
      showToast('Erreur lors de l\'envoi de l\'email.');
    }
  }

  function showToast(message, link) {
    const existing = document.querySelector('.pdnr-toast');
    if (existing) existing.remove();
    const toast = h('div', { class: 'pdnr-toast' });
    toast.appendChild(document.createTextNode(message));
    if (link) toast.appendChild(h('a', { href: link }, 'Voir →'));
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 400);
    }, 4000);
  }

  // ============================================================
  // STOREFRONT API (catalogue remote)
  // ============================================================
  // V5.8 — Résolution 100% dynamique via tags Shopify (canal Headless).
  // Convention catalogue : chaque produit complément porte les tags
  //   type_complement
  //   complement_{actif_key}    ex. complement_magnesium, complement_omega3
  // Le CATALOGUE local ne sert plus que pour les données cliniques (forme,
  // dosage, moment, duree, why). Aucune marque ni prix locaux n'est affiché :
  // seules les valeurs Storefront (vendor + price + variantId + featuredImage)
  // alimentent l'UI commerce. Si un actif n'a pas de produit Headless tagué,
  // sa carte se rend en mode éducatif (pas de prix, pas de bouton panier).
  // Joker canonique par actif — 1 produit dédié désigné par actif_key (cf. JOKERS
  // du quiz peau). Le bilan résout chaque actif sur SON produit dédié plutôt que
  // sur le premier-arrivé. Les multi-actifs gardent leurs tags complement_* (dédup
  // /scoring) mais ne gagnent plus la résolution. Actif absent ici → premier-arrivé.
  const NUTRITION_JOKERS = {
    vitamine_d: 'PD-0358', magnesium: 'PD-0356', omega3: 'PD-0322',
    omega3_algue: 'PD-0386', zinc: 'PD-0357', fer_femme: 'PD-0368',
    b12: 'PD-0359', probiotiques: 'PD-0341', vitamine_c: 'PD-0360',
    collagene: 'PD-0351', ashwagandha: 'PD-0544', coq10: 'PD-0361',
    vitamine_b: 'PD-0370', melatonine: 'PD-0369', inositol: 'PD-0385',
    glutathion: 'PD-0363', nac: 'PD-0362', berberine: 'PD-0349',
    lycopene_carotenoides: 'PD-0384', spiruline: 'PD-0542',
    zinc_selenium: 'PD-0467', maca: 'PD-0365', curcuma: 'PD-0543'
  };

  function loadStorefrontCatalogue() {
    const token = window.PARADERMIA_NUTRITION_STOREFRONT_TOKEN;
    const shop = window.Shopify && window.Shopify.shop;
    if (!token || !shop) {
      console.log('[Bilan Résultats] Storefront non configuré — UI en mode éducatif (pas de panier).');
      return Promise.resolve(null);
    }
    const query = `
      query getComplements {
        products(first: 100, query: "tag:type_complement") {
          edges { node {
            handle title vendor tags
            featuredImage { url }
            variants(first: 1) { edges { node { id price { amount } } } }
          } }
        }
      }`;
    return fetch('https://' + shop + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query }),
    })
      .then(r => r.json())
      .then(data => {
        const edges = (data && data.data && data.data.products && data.data.products.edges) || [];
        const map = {};
        edges.forEach(e => {
          const n = e.node;
          const v = n.variants.edges[0] && n.variants.edges[0].node;
          if (!v) return;
          const pdCode = (n.tags || []).find(t => t.indexOf('PD-') === 0) || null;
          const entry = {
            variantId: parseInt(v.id.replace(/\D/g, ''), 10),
            price: parseFloat(v.price.amount),
            title: n.title,
            handle: n.handle,
            vendor: n.vendor,
            tags: n.tags || [],
            pd: pdCode,
            imageUrl: n.featuredImage && n.featuredImage.url,
          };
          // Indexation par actif_key extrait du tag `complement_{actif_key}`.
          // Un même produit peut porter plusieurs tags actifs (ex. Oxyprolane
          // Dermic : complement_collagene + complement_omega3) → on indexe
          // sur chaque actif_key, premier-arrivé prioritaire (stable).
          (n.tags || []).forEach(t => {
            if (t.indexOf('complement_') === 0) {
              const actifKey = t.slice('complement_'.length);
              if (!actifKey) return;
              // Joker canonique (produit dédié) prioritaire ; sinon premier-arrivé.
              const joker = NUTRITION_JOKERS[actifKey];
              const isJoker = joker && pdCode === joker;
              if (isJoker || !map[actifKey]) map[actifKey] = entry;
            }
          });
        });
        _catalogueRemote = map;
        console.log('[Bilan Résultats] Catalogue Storefront résolu via tags :',
          Object.keys(map).length, 'actif_keys →', Object.keys(map).join(', '));
      })
      .catch(err => console.warn('[Bilan Résultats] Storefront fetch failed :', err));
  }

  // ============================================================
  // RESTORE DAWN CHROME, header / footer / announcement bar
  // ============================================================
  // La page résultats sort du mode immersion : on s'assure que le header,
  // le footer et la barre d'annonce Dawn sont visibles. Défense contre :
  //  1. body.pd-quiz-active / pdn-quiz-active qui auraient persisté du quiz
  //     (les CSS de masquage du quiz peau ciblent ces classes, voir
  //     quiz-paradermia.css l.5946 .shopify-section-group-footer-group).
  //  2. inline display:none !important posé par hideNav() côté skin sur
  //     le même domaine (cache Section Rendering possible inter-page).
  // Symétrie avec showNav() côté skin (quiz-paradermia.js l.584).
  const DAWN_NAV_SELECTORS = [
    '#shopify-section-header',
    '.shopify-section-group-header-group',
    '.header-wrapper',
    '.shopify-section-header-sticky',
    '#shopify-section-announcement-bar',
    '.announcement-bar',
    '.utility-bar',
    '.shopify-section-group-footer-group',
    '#shopify-section-footer',
    '.site-footer',
    '.section-footer',
    'footer[role="contentinfo"]',
  ];
  function restoreDawnChrome() {
    document.body.classList.remove('pd-quiz-active', 'pdn-quiz-active');
    // Marqueur permettant aux CSS overrides de viser cette page spécifiquement
    // (voir bilan-nutrition-resultats.css : `body.pdnr-results-active …`).
    document.body.classList.add('pdnr-results-active');
    DAWN_NAV_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        el.style.removeProperty('display');
        // Force display:block si le removeProperty laisse encore display:none
        // (cas observé sur paradermia.myshopify.com avec inline !important
        // qui survit à removeProperty, symétrie skin showNav l.597).
        if (getComputedStyle(el).display === 'none') {
          el.style.setProperty('display', 'block', 'important');
        }
      });
    });
  }

  // ============================================================
  // BOOTSTRAP
  // ============================================================
  // V5 — gardes typeof pour permettre require() en Node (tests purs sur
  // getActiveSynergies / computeIsCure). En browser, comportement inchangé.
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      const root = document.querySelector('[data-bilan-resultats-root]');
      if (!root) return;
      // Restaure le header/footer Dawn dès que le DOM est prêt (avant render
      // pour éviter tout flash visuel d'immersion au chargement).
      restoreDawnChrome();
      bilan = loadBilan();
      if (bilan) console.log('[Bilan Résultats] sessionStorage chargé :', bilan);
      app = { root };
      loadStorefrontCatalogue().finally(() => { render(); pushProtocole(); });
      // V5.3 — fetch async des produits upsell en parallèle. Le render
      // affiche d'abord 4 skeletons, qui sont remplacés par les vraies
      // cartes au retour du fetch (loadUpsellProducts trigger render()).
      loadUpsellProducts();
      render();
    });
  }

  if (typeof window !== 'undefined') {
    window.ParaDermiaBilanResultats = { render, loadBilan, CATALOGUE };
  }

  // Export Node pour tests unitaires sur les fonctions pures.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { getActiveSynergies, computeIsCure, WHY_CURE_SYNERGIES, WHY_ACTIFS_NUTRITION };
  }
})();

